const translation = {
IDS_OK:'OK',
IDS_SELECTED_TO_CALC: 'Кандидат для рассчета',
IDS_CANCEL:'Отмена',
IDS_YES:'Да',
IDS_NO:'Нет',
IDS_STOP:'Стоп',
IDS_CANCELLING:'Отмена...',
IDS_CLOSE:'Закрыть',
IDS_BROWSE:'Обзор',
IDS_SELECT:'Выбрать',
IDS_CELLPROP:'Свойства ячейки',
IDS_PRJ_ROOT:'Проект',
IDS_PRJ_GRIDS:'Сетки',
IDS_PRJ_GRID_GEOMETRY: 'Геометрия сетки',
IDS_PRJ_STRUCTURE:'Структура',
IDS_PRJ_STATIC_PARAMETERS:'Статические параметры',
IDS_PRJ_DYNAMIC_PARAMETERS:'Динамические параметры',
IDS_PRJ_NO_PARAMETERS:'Параметры отсутствуют',
IDS_PRJ_DYNAMIC_PARAMETER_STEPS:'Временные шаги',
IDS_PRJ_DYNAMIC_PARAMETER_NO_STEPS:'Временные шаги отсутствуют',
IDS_PRJ_WELLS:'Скважины',
IDS_PRJ_WELLGROUPS:'Группы скважин',
IDS_PRJ_TWO_WELLGROUPS:'Две группы скважин',
IDS_PRJ_THREE_WELLGROUPS:'Три группы скважин',
IDS_PRJ_HORIZONS: 'Поверхности',//'Горизонты',
IDS_PRJ_HORIZON: 'Поверхность', //'Горизонт',
IDS_PRJ_MAPS:'Карты',
IDS_PRJ_FAULTS:'Разломы',
IDS_PRJ_STRUCTURAL_MODELS:'Структурные модели',
IDS_PRJ_BLOCKED_WELLS:'IJK-Скважины',
IDS_PRJ_WELL_PICKS:'Пластопересечения',
IDS_PRJ_ZONES:'Пласты',
IDS_PRJ_ZONE:'Пласт',
IDS_FENCES:'Разрезы',
IDS_REGIONS:'Регионы',
IDS_NONE:'Нет',
IDS_RDS_DATABASE:'База данных',
IDS_DATA_SOURCE:'Источник данных',
IDS_RDS_FIELD_INFORMATION:'Промысловая информация',
IDS_RDS_MODEL:'Двумерная модель',//'Вариант данных',
IDS_FIELD:'Месторождение',
IDS_SHOULD_SELECT_DATABASE:'Вы сначала должны выбрать источник промысловой информации',
IDS_MODEL:'Модель',
IDS_RESERVOIR:'Эксплуатационный объект',
IDS_STORAGE_MODELS:'Проекты',//'Модели',
IDS_PRJSEL_DATABASES:'Источники данных',//'Базы данных',
IDS_PRJSEL_FIELDS:'Месторождения',
IDS_PRJSEL_MODELS:'Двумерные модели',//'Варианты данных',
IDS_PRJSEL_RESERVOIRS:'Эксплуатационные объекты',
IDS_PRJSEL_NAME:'Имя',
IDS_PRJSEL_DESCRIPTION:'Описание',
IDS_PRJSEL_ZONEPROP:'Параметры пластов',
IDS_PRJSEL_WELLPROD:'Промысловые данные',
IDS_RESERVES_DESC_RES:'Запасы нефти',
IDS_RESERVES_DESC_DEN:'Плотность запасов нефти',
IDS_K_PROD:'Коэффициент продуктивности',
IDS_ENTIRE_REGION: 'Вся модель',
IDS_WELLSRANGE_WOC_REGION: 'Нефтенасыщенная зона',
IDS_HORIZON_TOP_OF: 'Кровля ',
IDS_HORIZON_ENTIRE_REGION: 'Кровля модели',
IDS_HORIZON_WELLSRANGE_WOC_REGION: 'Водонефтяной контакт',
IDS_GRID_PARAMETERS:'Параметры',
IDS_INIT:'Статические',
IDS_REST:'Динамические',
IDS_TOTAL:'Всего',
IDS_ACTIVE:'Активных',
IDS_NAME:'Имя',
IDS_WELL3D:'Сква\xADжи\xADна',
IDS_IMPORT:'Импорт',
IDS_EXPORT:'Экспорт',
IDS_SECT_RESET:'Очистить',
IDS_CALCULATOR: 'Калькулятор',
IDS_AI_CHAT: 'VEGO ИИ ассистент',
IDS_ARITHM_CMD: 'Командная строка',
IDS_FC_TITLE:'Фильтр по ячейкам',
IDS_FC_COORDS:'Координаты',
IDS_FC_CANCEL:'Отмена',
IDS_FC_APPLY:'Применить',
IDS_FC_RESET:'Сбросить',
IDS_FC_MORE_GRID_PARAMETERS:'Показать другие параметры',
IDS_FC_HIDE_MORE_GRID_PARAMETERS:'Скрыть другие параметры',
IDS_PPD_LIQUIDPROD:'Добыча жидкости',
IDS_PPD_OILPROD:'Добыча нефти',
IDS_PPD_EFFICFUNCTION:'Целевая функция',
IDS_PPD_WEIGHT_COEFF:'Весовые коэффициенты',
IDS_PPD_COORD_DESC:'Покоординатный спуск',
IDS_PPD_MONTE_CARLO:'Монте-Карло',
IDS_PPD_TOTAL_INJ:'Закачка',
IDS_PPD_OILP_INCR:'Изменение добычи нефти',
IDS_PPD_INJ_INCR: 'Изменение закачки воды',
IDS_PPD_LIQUID_INJECTION_INCR: 'Liquid injection increment',
IDS_PPD_SUMINJ:'Закачка по вар-ту',
IDS_PPD_OL_VAR:'Изменение добычи нефти и жидкости',
IDS_PPD_VAR_SUMMARY:'Информация по варианту',
IDS_VAR_DETAILS:'Информация по варианту',
IDS_BASE_VARIANT: 'Базовый вариант',
IDS_OPT_VARIANT:'Вариант',
IDS_PPD_OIL_DELTA:'Изменение добычи нефти',
IDS_PPD_LIQUID_DELTA:'Изменение добычи жидкости',
IDS_PPD_OIL:'Нефть',
IDS_PPD_WATER:'Вода',
IDS_PPD_PERCWOPT:'Доб. нефти от базы',
IDS_PPD_GOALVALUE:'Знач-е Ц.Ф.',
IDS_STATISTIC_MINVAL:'Мин.',
IDS_STATISTIC_MAXVAL:'Макс.',
IDS_STATISTIC_SUM:'Суммарное',
IDS_STATISTIC_AVERAGE:'Среднее',
IDS_REGION_STATISTICS:'Статистика по региону',
IDS_PATH_TO_MODEL: 'Путь к модели',
IDS_CENTER:'Поместить в центр окна',
IDS_SAVE:'Сохранить',
IDS_OPEN:'Открыть',
IDS_OPTION3D_BUBBLES:'Круговые диаграммы',
IDS_OPTION3D_CELLS:'Сетка',
IDS_OPTION3D_GRIDLINE_CELLS:'Линии сетки 3D-ячеек',
IDS_OPTION3D_FILL_CELLS:'Заливка ячеек сетки',
IDS_OPTION3D_HORIZONS:'Горизонты',
IDS_OPTION3D_LIGHT:'Свет',
IDS_OPTION3D_WELLS:'Скважины',
IDS_OPTION3D_GRIDLINES:'Линии сетки поверхности',
IDS_OPTION3D_HILLSHADING:'Затенение рельефа',
IDS_OPTION3D_LEVELS:'Изолинии',
IDS_OPTION3D_MAPS:'Карты',
IDS_OPTION3D_MAP_GRIDLINES:'Линии сетки карты',
IDS_TOTBLOCKNUM:'Количество ячеек',
IDS_ACTBLOCKNUM:'Активные ячейки',
IDS_WELLNUM:'Коли\xADчество скважин',
IDS_SIZE:'Размер',
IDS_CREATE_SON_MODEL:'Создать расчетную модель',
INF_PRJREADING_OPEN:'Открывается проект...',
INF_PRJREADING_OPEN_RDS:  "Открывается база данных RDS...",
INF_CALC_OPTIMIZATION_WELLS:  "Составляется список скважин для оптимизации...",

IDS_STOP_PROCESS_QUESTION:'Вы действительно хотите прервать процесс?',
IDS_CALC_MOBRESERVES:'Рассчитываются подвижные запасы...',
IDS_MOBRESERVES_DESC_DEN:'Плотность подвижных запасов нефти',
IDS_MOBRESERVES_DESC_RES:'Подвижные запасы нефти',
IDS_REL_AV_PRES_DESC:'Изменение среднего давления',
IDS_TYPE:'Тип файла',
IDS_BACK:'Назад',
IDS_FINISH:'Закончить',
IDS_SKIP:'Пропустить',
IDS_NEXT_STEP:'Далее',
IDS_OPEN_GUIDE:'Показать инструкцию',
IDS_PAGE_TITLE_3DVIEW:'3D визуа\xADлизация',
IDS_PAGE_TITLE_AVE_PRESSURE:'Пластовое давление',//'Карта давления',
IDS_CALC_FORMATION_PRESSURE:'Расчет пластового давления',
IDS_CALC_PERMEABILITY:'Расчет проницаемости',
IDS_FLOW_MODEL: 'Гидродинамическая модель',
IDS_PAGE_TITLE_MOB_RESERVES:'Подвижные запасы',//'Карта подвижных запасов',
IDS_PAGE_TITLE_TRAJED:'Редактор траектории',
IDS_PAGE_TITLE_PERF_EDITOR:'Редактор перфораций',
IDS_PAGE_TITLE_2DVIEW:'2D визуа\xADлизация',
IDS_PAGE_TITLE_SECTION:'Разрез',
IDS_PAGE_BEFOREUNLOAD:'Вы действительно хотите уйти из аппликации?',
IDS_PAGE_TITLE_WELLPLACE:'Оценка местоположения скважины',
IDS_PAGE_TITLE_WELLPATTERN:'Расстановка по шаблону',
IDS_PAGE_TITLE_WELLPRODUCT:'Расчет прогнозных показателей',
IDS_WATER_CUT:'Обвод\xADнен\xADность',
IDS_TOTAL_PROD:'Итого',
IDS_PERF_LENGTH:'Длина',
IDS_PERFORATION_LENGTH:'Длина интервалов перфораций',
IDS_PERF_INTERVALS:'Интервалы перфораций',
IDS_PAGE_WF_OPTIMIZATION:'ППД',
IDS_PPD_DAY:'Сутки',
IDS_PPD_WATER_INJ:'Закачка воды',
IDS_PPD_WATER_PROD:'Добыча воды',
IDS_PPD_OIL_PROD:'Добыча нефти',
IDS_PPD_CREATE_SIM_MODEL:'Создать расчетную модель',
IDS_PPD_WELLS_MODE:'Режимы скважин',
IDS_PPD_RETURN:'Вернуться к таблице',
IDS_WELLSRANGE_INF_NO_SELECTED_VAR:'Ни одна скважина не выделена',
IDS_SETTINGS:'Настройки',
IDS_OPTIONSTAT_ALLPROPS:'Все свойства',
IDS_COLOR_LEGEND:'Цветовая легенда',
IDS_GEOLOGY:'Геология',
IDS_GEOLOGICAL_MODEL:'Геологи\xADческая модель',
IDS_HYDRODYNAMIC_MODEL:'Гидродина\xADмическая модель',
IDS_NO_WEBGL:'Ваш браузер не поддерживает WebGL',
IDS_NO_WEBGL20:'Ваш браузер не поддерживает WebGL 2.0',
IDS_RESCAN_MODELS_FOLDER:'Перечитать информацию о моделях',
IDS_SCANNING_MODELS_FOLDER:'Чтение информации о моделях...',
IDS_CREATE_PROJECT:'Создать проект',
IDS_DELETE_PROJECT:'Удалить проект',
IDS_GEOLOGICAL_SECTIONS:'Геологичес\xADкий разрез',
IDS_DELETE_PROJECT_CONFIRM:'Вы уверены, что хотите удалить проект?',
IDS_PROJECT_NOT_SELECTED: 'Не выделен проект',
IDS_CREATE_PROJECT_FOLDER:'Создать папку',
IDS_DELETE_PROJECT_FOLDER:'Удалить папку',
IDS_DELETE_PROJECT_FOLDER_CONFIRM:'Вы уверены, что хотите удалить папку?',
IDS_EDIT_PROJECT:'Редактировать проект', // модель',
IDS_OPEN_MODEL:'Открыть проект', // модель',
IDS_BRIEF_MODEL_INFO:'Краткая информация о модели',
IDS_REPORT_DOCUMENTS:'Отчетные документы',
IDS_ADDITIONAL_FILES:'Сопроводительные файлы',
IDS_MODEL_NAME:'Название модели',
IDS_MODEL_DESCR:'Описание',
IDS_MODEL_TYPE:'Формат модели',
IDS_MODEL_START_DATE:'Время начала расчета',
IDS_MODEL_END_DATE:'Время окончания',
IDS_MODEL_ACTIONS:'Действия',
IDS_CALC_RESULTS:'Результаты расчета',
INF_WELL3D_TRACE_WELLS:'Производятся вычисления...',
IDS_CALCULATING_STATISTICS:'Получение статистики...',//'Вычисление статистики...',
IDS_ACTION_RUN:'Рассчитать',
IDS_ACTION_RESULTS:'Результаты',
IDS_ACTION_RUN_PROXY:'Запуск на расчет',
IDS_MODEL_PROD_DATA:'Техноло\xADгические показа\xADтели',
IDS_PROD_DATA:'Промыс\xADловые данные',
IDS_ACTION_RERUN_TEMPEST:'Выходные файлы модели уже существуют.<br>Вы действительно хотитет повторно произвести расчет?',
IDS_MODEL_STATISTICS:'Статистика',
IDS_NO_DATA:'Нет информации по выбранному объекту',
IDS_NO_DATA_BY_TIMESTEP: 'Нет информации по выбранному объекту на данный временной шаг',
IDS_VAR_INTEGRAL_PARAMS:'Интегральные характеристики по варианту',
IDS_CUR_GEOL_RESERVES:'Текущие геологические запасы',
IDS_REMAIN_RESERVES:'Остаточные',
IDS_PRODUCTION_RESERVES:'Добыча',
IDS_INITIAL_RESERVES:'Начальные',
IDS_AREA:'Регион',
IDS_KT:'тыс. т',
IDS_MT:'млн. т',
IDS_REGIONS_AREAS:'Регионы',
IDS_TOOLTIPS:'Всплывающая подсказка',
IDS_WARNING:'Внимание!',
IDS_EMPTY_RESERVES1:'В модели отсутствуют данные для расчета гистограмм запасов по регионам.',
IDS_EMPTY_RESERVES2:'Необходимо проверить наличие свойства \'OIIP\' в выдаче исходной модели.',
IDS_WELLEVENT_TYPE:'Тип',
IDS_WELL_CONTROL:'Контроль',
IDS_INDEX_PERF:'№',
IDS_DATE_PERF:'Дата',
IDS_TYPE_PERF:'Тип',
IDS_TOP:'Кровля',
IDS_BOTTOM:'Подошва',
IDS_FROM_PERF:'От',
IDS_TO_PERF:'До',
IDS_WELL_LIMITS:'Ограничение',
IDS_WELL_PRODUCT:'Добывающая',
IDS_WELL_INJECTION:'Нагнетательная',
IDS_WELL_STOPPED:'Неактивная',
IDS_WELL_PRES:'Давление',
IDS_WELL_LIQUID:'Дебит жид\xADкости',
IDS_WELL_INJECTRATE:'Прие\xADмис\xADтость',
IDS_WELL_BHP:'Заб. давление',
IDS_INJECTIVITY_DEBIT: 'Приемистость/Дебит',
IDS_WELLEVENT_EDIT:'Редактировать',
IDS_SMCUBE:'м\u00B3', // 'м3'
IDS_BAR:'бар',
IDS_MD:'мД',
IDS_CP:'сПз',
IDS_FACT:'Факт.',
IDS_CALC:'Расч.',
IDS_PROBABILITY:'Вероятность',
IDS_DENS_PROBABILITY:'Плотность вероятности',
IDS_WELL_TYPES:'Типы скважин',
IDS_NOTATIONS:'Условные обозначения',
IDS_PI_TITLE:'Результаты расчета',
IDS_MIN_DIST:'Допустимое расстояние',
IDS_CASING_DIAMETER:'Диаметр колонны',
IDS_SHOW_ALL_WELLS:'Показать все',
IDS_SHOW_FILTERED_WELLS:'Показать только отфильтрованные',
IDS_PI_PRESSURE:'Забойное давление',
IDS_PI_RESULTED_SKIN:'Cкин',
IDS_PI_WELL_RADIUS:'Радиус скважины',
IDS_WELL_EVENTS:'События по скважинам',
IDS_WELL_PERFORATIONS:'Перфорации',
IDS_WELL_WDEBIT:'Qв',
IDS_WELL_ODEBIT:'Дебит нефти',
IDS___EVAL:'Оценка',
IDS___CALC:'Расчет',
IDS_UNCERTAIN_ERR_MESSAGE:'Не найдено перфораций на текущий временной шаг',
IDS_PI_PERMEABILITY:'Прони\xADца\xADемость',
IDS_PI_PERMEABILITY_Z:'Вертикальная проницаемость',
IDS_PI_PERMEABILITY_X:'Латеральная проницаемость',
IDS_PI_PERMEABILITY_CONF_INVERVAL:'Доверительный интервал',
IDS_WELLTRACK:'Траектория',
IDS_SIDETRACK:'Траектория',
IDS_PROD_UNITS:'м\u00B3/(сут*бар)', // 'м3/(сут*бар)'
IDS_PI_RESULTED_PRODUCTIVITY:'Продуктивность',
IDS_PI_UNCERTAINTY:'Расчет неопределенности дебита',
IDS_PERM_STD:'Ср. квадр. отклонение проницаемости',
IDS_WELL_NAME:'Имя',
IDS_PROD_WELL_NAME:'Имя скважины',
IDS_RESERVES:'Геоло\xADги\xADческие запасы',
IDS_WELL_PRODUCTIVITY:'Продук\xADтив\xADность',
IDS_WELL_RESERVES:'Подвижные запасы',
IDS_TONS:'т',
IDS_METERS:'м',
IDS_PIECE:'шт',
IDS_CLEAR_TABLE_MESSAGE:'Вы действительно хотите очистить таблицу?',
IDS_CLEAR_TRAJ_MESSAGE:'Вы действительно хотите очистить траекторию скважины?',
IDS_CLEAR_PERF_MESSAGE:'Вы действительно хотите удалить все перфорации?',
IDS_RESERVES_AREA:'Площадь',
IDS_SQUARE_METERS:'м\u00B2', // 'м2'
IDS_KILO:'тыс.',
IDS_CUBE_METERS:'м\u00B3', // 'м3'
IDS_CUBE_METERS_DAY:'м\u00B3/сут', // 'м3/сут'
IDS_FRACTION:'доля',
IDS_YEAR:'год',
IDS_BASIC:'Базовый',
IDS_MINVAL:'Мин.',
IDS_MAXVAL:'Макс.',
IDS_NUMVALUES:'Кол-во значений',
IDS_NUMVARIANTS:'Кол-во вариантов',
IDS_NUMPIECES:'Кол-во, шт.',
IDS_OPT_VARIANTS:'Варианты',
IDS_OPT_NORMALIZED:'Нормированные значения',
IDS_OPT_CONDITIONS:'Условия оптимизации',
IDS_OPT_FIXTOTAL:'Фиксированная закачка',
IDS_OPT_TIMEPERIOD:'Период расчета',
IDS_OPT_DATESTART: 'Текущая дата',
IDS_OPT_DATEND:'Дата окончания расчета',
IDS_OPT_METHODS:'Методы оптимизации',
IDS_OPT_SETTING:'Настройки оптимизации',
IDS_OPT_WELLS:'Скважины',
IDS_NO_INJWELLS:'В заданном регионе нет ни одной нагнетательной скважины,\r\nили приемистость скважин на последний временной шаг модели равна нулю.',
IDS_PROB_DENS:'Плотность вероятности',
IDS_PROB_DIST:'Распределение вероятности',
IDS_SHOW_MORE:'Показать еще',
IDS_SHOW_LESS:'Скрыть',
IDS_SHOW_SECTION:'Показать разрез',
IDS_CLEAR_SECTION:'Очистить разрез',
IDS_REGION_RESERVES:'Запасы по регионам',
IDS_HIST_LABEL_CELLS:'Ячейки',
IDS_MULTIVARIANT_CALCULATION:'Оценка неопределенностей',
IDS_STRUCTURAL_MODELING:'Структурное моделирование',
IDS_FAULT_MODELING:'Моделирование разломов',
IDS_HORIZON_MODELING:'Моделирование горизонтов',
IDS_GRID_MODELING:'Построение 3D сетки',
IDS_BW_MODELING:'Построение IJK-скважин',
IDS_FACIES_INDICATOR_MODELING:'Фациальное моделирование',
IDS_RUN_JOB:'Выполнить',
IDS_RUN_WORKFLOW:'Выполнить',
IDS_CREATE_FAULT_MODEL:'Создать модель разломов',
IDS_CREATE_HORIZON_MODEL:'Создать модель горизонтов',
IDS_CREATE_GRID:'Создать 3D сетку',
IDS_CREATE_BW:'Создать IJK-скважины',
IDS_CREATE_FACIES_INDICATOR_MODEL:'Создать модель фаций',
IDS_SAVE_THE_PROJECT:'Сохранить проект',
IDS_MODEL_PUBLISH:'Опубликовать модель',
IDS_MODEL_PASSPORT:'Паспорт модели',
IDS_MODEL_GPD:'ГФХ',
IDS_MODEL_ECONOMIC_PASSPORT:'Экономический паспорт модели',
IDS_CHOOSE_MODEL_FOR_START:'Для начала работы необходимо выбрать проект слева в дереве проектов',
IDS_CHOOSE_OR_CREATE_MODEL_FOR_START:'Для начала работы необходимо создать или выбрать проект слева в дереве проектов',
IDS_CALC_PERFS_BUTTON:'Рассчитать',
IDS_APPLY_SUGGESTED_PERFS_BUTTON:'Применить',
IDS_CALC_PERFS_HEADER:'Настройки перфораций',//'Фильтр на перфорации',
IDS_WISH_SAVE_CHANGES:'Сделанные Вами изменения в траектории и перфорациях будут потеряны. Сохранить изменения?',
IDS_PRJ_CREATE_SUCCESS:'Модель успешно создана',
IDS_HIGHLIGHT_SELECTED_WELLS:'Подсвечивать выбранные скважины',
IDS_KRUBLES:'тыс. руб.',
IDS_ADD_WELL:'Добавить новую скважину',
IDS_IMPORT_WELLS:'Импортировать скважины...',
IDS_IMPORT_WELLS_FROM_MODEL:'Импортировать скважины из модели...',
IDS_IMPORT_WELLS_FROM_FILE:'Импортировать скважины из файла...',
IDS_IMPORT_WELLS_FROM_RDS:'Импортировать скважины из базы данных...',
IDS_IMPORT_TRAJECTORY_FROM_STORAGE:'Импортировать траекторию из модели...',
IDS_IMPORT_TRAJECTORY_FROM_FILE:'Импортировать траекторию из файла...',
IDS_DEL_WELL:'Удалить',
IDS_RENAME_WELL:'Переименовать',
IDS_RENAME_REGION:'Переименовать',
IDS_PERF_SHORT:'П',
IDS_ISOL_SHORT:'И',
IDS_ADD_WELL_BRANCH:'Добавить боковой ствол',
IDS_RUN_PLUGIN: 'Запуск плагина...',
IDS_BUILD_LEVELS: 'Построение изолиний...',
IDS_LOAD_SECT_DATA: 'Получение данных разреза...',
IDS_LOAD_DIAG_DATA: 'Получение данных диаграммы...',
IDS_LOAD_2D_GRID_DATA: 'Получение данных карты...',
IDS_LOAD_3D_GRID_DATA: 'Получение данных 3D сетки...',
IDS_LOAD_CELL_DATA: 'Получение свойств ячейки...',
IDS_LOAD_PRODUCTION_DATA: 'Получение промысловых данных...',
IDS_LOAD_FROM_DB:'Загрузить данные',
IDS_START_WELL_BRANCH:'Начать боковой ствол',
IDS_CALC_WELL_BRANCH:'Рассчитать боковой ствол',
IDS_CALC_WELL_BRANCH_CHART:'Распределение продуктивности',
IDS_SAVE_RESULTS:'Применить',
IDS_RUN_BRANCH_OPTIMIZATION:'Оценка рисков',
IDS_CALC_PRODUCTIVITY:'Рассчитать',
IDS_STOPPED_OR_INJECTOR_WELL: "остановленная или нагнетательная скважина",
IDS_DEL_PERF:'Удалить',
IDS_OMD_FILE_ACTIONS:'Действия',
IDS_OMD_DOCUMENT_CALCULATE:'Рассчитать',
IDS_OMD_DOCUMENT_RECALCULATE:'Пересчитать',
IDS_OMD_DOCUMENT_STOP:'Остановить',
IDS_OMD_FILE_ACCEPT:'Принять',
IDS_OMD_FILE_REJECT:'Отклонить',
IDS_OMD_FILE_ADD_DESCRIPTION:'Добавить описание',
IDS_EDIT_SHORTPROD:'Прогноз добычи',
IDS_EDIT_MIDDLEPROD:'Среднесрочный прогноз добычи',
IDS_EDIT_FLOWMODEL:'Создание фильтрационной модели',
IDS_OPT_INJECTIVITY:'Прие\xADмис\xADтость',
IDS_OPT_BHP:'Забойное давление',
IDS_OPT_BHP_INJ:'Забойное давление. Нагнетание',
IDS_OPT_BHP_PROD:'Забойное давление. Добыча',
IDS_OPT_PARAMETERS:'Управляющие параметры',

IDS_WELL_DIAG:'Диаграмма скважины',
IDS_WELLS_DIAG:'Диаграмма скважин',
IDS_WELLS_DIAG_READOUT: 'Информация',
IDS_WELL_DIAG_FLATTING: 'Выравнивание по горизонту', // Выравнивание по маркирующему горизонту. Приведение к опорному горизонту. Спрямление горизонтов.
IDS_WELL_DIAG_UNFLATTING: 'Отмена выравнивания', // (по горизонту) 
IDS_WELLDIAG_VIEWER:'Окно: Диаграмма скважины',
IDS_PRODCARD_VIEWER:'Окно: Эксплуатационная карточка скважины',
IDS_WELL_SHOW_SECTION:'Показать разрез',
IDS_WELL_ADD_TO_SECTION:'Добавить на разрез',
IDS_WELL_DEL_FROM_SECTION:'Убрать с разреза',
IDS_WELL_ADD_TO_DIAGRAM: 'Добавить на диаграмму',
IDS_WELL_DEL_FROM_DIAGRAM: 'Убрать с диаграммы',
IDS_TYPE_NEW_WELL:'Тип новой скважины',
IDS_HORIZONTAL_WELL:'Горизонтальная скважина',
IDS_VERTICAL_WELL:'Вертикальная скважина',
IDS_AZIMUTH_NEW_WELL: 'Азимут',
IDS_ROTATION_NUM_NEW_WELL: 'Количество поворотов',
IDS_LENGTH_NEW_WELL:'Длина',
IDS_INCLINATION_NEW_WELL:'Отклонение от вертикали',
IDS_SIDETRACK_PROD_DISTRIBUTION_CALC:'Вычисление дебита вариантов бокового ствола',
IDS_PRODUCTIVITY_COMPUTATION:'Прогноз дебита скважины',
IDS_BRANCH_STICKING_OUT_ACTION:'Действия с выступающей частью',
IDS_BRANCH_STICKING_OUT_NO:'Оставлять как есть',
IDS_BRANCH_STICKING_OUT_TRUNCATE:'Обрезать',
IDS_BRANCH_STICKING_OUT_BEND:'Загибать',
IDS_CALC_WELL_BRANCH_GEOMETRY:'Создать траекторию',
IDS_CALC_WELL_BY_TEMPLATE:'По шаблону',
IDS_SWEET_SPOT_STEP: 'Шаг',
IDS_SWEET_SPOT_NUM_VARIANTS: 'Макс. кол-во вариантов',
IDS_PRESSURE_CHARACTERISTICS:'Характеристики поля давлений',
IDS_LIQUID:'Жидкость',
IDS_SOIL:'Нефте\xADна\xADсы\xADщен\xADность',
IDS_IMPORT_FROM_RMS:'Импортировать из проекта RMS',
IDS_IMPORT_FROM_PROJECT: 'Из проекта',
IDS_IMPORT_FROM_FILE:'Из файла',
IDS_CALC_WELL_BRANCH_ADDITION:'Дополнительно',
IDS_CALC_WELL_BRANCH_SAVE:'Сохранить',
IDS_CALC_WELL_BRANCH_CANCEL:'Закрыть',
IDS_CALC_WELL_BRANCH_CREATE:'Создать',
IDS_START_WELL_POINT:'Задайте на карте начальную точку траектории двойным щелчком мышки',
IDS_START_WELL_BRANCH_POINT:'Задайте на разрезе родительского ствола точку врезки бокового ствола',
IDS_MOVE_WELL_POINT:'При необходимости переместите на карте начальную точку траектории',
IDS_MOVE_WELL_BRANCH_POINT:'При необходимости переместите на разрезе родительского ствола точку врезки бокового ствола',
IDS_CREATE_TRAJ_METHOD:'Способ задания',
IDS_CREATE_TRAJ_MANUALLY:'Ручной',
IDS_CREATE_TRAJ_BY_PARAMS:'По параметрам',
IDS_TRUNCATE_TRAJ:'Обрезка траектории на разрезе',
IDS_SHOW_LABEL_TVD:'Метки по TVD',
IDS_SHOW_LABEL_MD:'Метки по MD',
IDS_APPLICATION_SETTINGS:'Настройки',
IDS_SHOW_MORE_SETTINGS:'Прочие',
IDS_GENERAL_INFO:'Общая информация',
IDS_RESERVES_PER_WELL:'Подвижные запасы на скважину',
IDS_WELLBORE_LENGTH:'Длина ствола',
IDS_WELL_PRODUCTION:'Продуктивность скважины',
IDS_CREATE_SIMUL_MESS:'Вы действительно хотите создать фильтрационную модель?',
IDS_DELTA_OIL_RATE:'Доп. добыча нефти',
IDS_RESERVOIR_PRES_CHANGE:'Изменение пластового давления',
IDS_GLPT:'Добыча жидкости',
IDS_WBHP:'Забойное давление',
IDS_WBHPH:'История забойного давления',
IDS_WGIR:'Приемистость газа',
IDS_WGIRH:'История приемистости закачки газа',
IDS_WGIT:'Накопленная закачка газа',
IDS_WGITH:'История накопленной закачки газа',
IDS_WLPR:'Дебит жид\xADкости',
IDS_WLPRH:'История дебита жидкости',
IDS_WOPR:'Дебит нефти',
IDS_WOPRH:'История дебита нефти',
IDS_WWPR:'Дебит воды',
IDS_WWPRH:'История дебита воды',
IDS_WOPT_CHANGE:'Изменение добычи нефти',
IDS_WOPT:'Накопленная добыча нефти',
IDS_WOPTH:'История накопленной добычи нефти',
IDS_WWPT:'Накопленная добыча воды',
IDS_WWPTH:'История накопленного отбора воды',
IDS_WGPR:'Дебит газа',
IDS_WGPRH:'История дебита газа',
IDS_WGPT:'Накопленная добыча газа',
IDS_WGPTH:'История накопленной добычи газа',
IDS_WWCT:'Обводненность',
IDS_WWCTH:'История обводненности',
IDS_WWIT:'Накопленная закачка воды',
IDS_WWIT_CHANGE:'Изменение закачки воды',
IDS_WWITH:'История накопленной закачки воды',
IDS_WWIR:'Прие\xADмис\xADтость',
IDS_WWIRH:'История приемистости закачки воды',
IDS_WLPT:'Накопленная добыча жидкости',
IDS_WLPT_CHANGE:'Изменение добычи жидкости',
IDS_WLPTH:'История накопленной добычи жидкости',
IDS_WOPT_PLOT:'Добыча нефти',
IDS_WOPR_PLOT:'Дебит нефти',
IDS_WLPT_PLOT:'Добыча жидкости',
IDS_WLPR_PLOT:'Дебит жидкости',
IDS_WWIR_PLOT:'Приемистость',
IDS_PERF_EDIT_MODE:'Режим редактирования',
IDS_PERF_VIEW_MODE:'Режим просмотра',
IDS_PRESS_DIFF_LESS:'Забойное давление должно быть меньше пластового',
IDS_MONTH_JAN:'Янв',
IDS_MONTH_FEB:'Фев',
IDS_MONTH_MAR:'Мар',
IDS_MONTH_APR:'Апр',
IDS_MONTH_MAY:'Май',
IDS_MONTH_JUN:'Июн',
IDS_MONTH_JUL:'Июл',
IDS_MONTH_AUG:'Авг',
IDS_MONTH_SEP:'Сен',
IDS_MONTH_OCT:'Окт',
IDS_MONTH_NOV:'Ноя',
IDS_MONTH_DEC:'Дек',
IDS_DAY_MON:'Пн',
IDS_DAY_TUE:'Вт',
IDS_DAY_WED:'Ср',
IDS_DAY_THU:'Чт',
IDS_DAY_FRI:'Пт',
IDS_DAY_SAT:'Сб',
IDS_DAY_SUN:'Вс',
IDS_CREATE_GRID_BTN:'Создание сетки',
IDS_INTERFERENCE:'Взаимовлияние',
IDS_WELL_INFO:'Информация по скважине',
IDS_WELL_3D_FENCE:'Разрез по скважине в 3D',
IDS_DURATION_CALC:'Длительность',
IDS_DELTA_PROPS_PPD:'Изменение показателей относительно базового варианта',
IDS_PPD_MIN_GREATER_MAX: 'Значение Мин. > Макс.',
IDS_PPD_MAX_LESS_MIN: 'Значение Макс. < Мин.',
IDS_PPD_OUT_OF_INTERVAL: 'Базовое значение за пределами интервала [Мин., Макс.]',
IDS_EFFECTIVE_INJECTIVITY: 'Эффективная Приемистоть',
IDS_TRANS_BACK_TO_PROD:'Вернуть в добычу',
IDS_PRESSURE_LIMIT: 'Ограничение по давлению',
IDS_DIAMETER_FILTER_CONDITION_FAILED: 'Условие фильтра по диаметру не выполняется.',
IDS_DISTANCE_FILTER_CONDITION_FAILED: 'Условие фильтра по длине отхода не выполняется.',
IDS_ODEBIT_FILTER_CONDITION_FAILED: 'Условие фильтра по дебиту не выполняется.',
IDS_WATERCUT_FILTER_CONDITION_FAILED: 'Условие фильтра по обводненности не выполняется.',
IDS_BRANCH_LENGTH_FILTER_CONDITION_FAILED: 'Условие фильтра по длине ствола не выполняется.',
IDS_ECLIPSE_SHUT_WELL:'Выбывшая',
IDS_ECLIPSE_PROD_WELL:'Добыва\xADющая', //  по нефти
IDS_ECLIPSE_OINJ_WELL:'Нагнета\xADтельная по нефти',
IDS_ECLIPSE_WINJ_WELL:'Нагнета\xADтельная', //  по воде
IDS_ECLIPSE_GINJ_WELL:'Нагнета\xADтельная по газу',
IDS_VEGO_GAS_WELL:'Добываю\xADщая по газу',
IDS_VEGO_PROD_WELL:'Добыва\xADющая',
IDS_UNKNOWN_WELL:'Бездейст\xADвующая',
IDS_PROD_STOPPED_WELL:'Остановка добыва\xADющей',
IDS_INJ_STOPPED_WELL:'Остановка нагнета\xADтельной',
IDS_STREAM_WELL_PROD:'Добыва\xADющая',
IDS_STREAM_WELL_INJ:'Нагнета\xADтельная',
IDS_APPLY:'Применить',
IDS_OPTIONMODEL_COORSYSTEM:'Система координат',
IDS_OPTIONMODEL_LEFTCOOR:'Левая',
IDS_OPTIONMODEL_RIGHTCOOR:'Правая',
//IDS_ADD_WELL_TO_SECTION:'На разрез не добавлено ни одной скважины. Чтобы добавить скважину на разрез, нужно нажать на кнопку \uFE19 рядом с именем нужной скважины в дереве слева.',
IDS_ADD_WELL_TO_SECTION:'Добавьте скважину на разрез, нажав на кнопку \uFE19 рядом с именем скважины в дереве слева.',
//IDS_ADD_WELL_TO_DIAGRAM:'На диаграмму не добавлено ни одной скважины. Чтобы добавить скважину на диаграмму, нужно нажать на кнопку \uFE19 рядом с именем нужной скважины в дереве слева.',
IDS_ADD_WELL_TO_DIAGRAM:'Добавьте скважину на диаграмму, нажав на кнопку \uFE19 рядом с именем скважины в дереве слева.',
IDS_CHOOSE_ANY_WELL:'Выберите скважину в дереве слева или создайте ее на карте',
IDS_CHOOSE_ANY_WELL_TO_CREATE_BRANCH:'Выберите скважину для зарезки в нее бокового ствола',
IDS_CHOOSE_SWEETSPOT_TO_CREATE_BRANCH: 'Зафиксируйте точку (sweetspot) для прохождения через нее бокового ствола',
IDS_CHOOSE_ANY_WELL_FOR_DIAGRAM:'Выберите скважину в дереве слева',
IDS_NEED_SAVE_FOR_CALC:'Расчет невозможен, так как скважина не сохранена. Сохранить?',
IDS_WELL_TRAJ_EMPTY:'XYZ-траектория скважины не содержит ни одной точки',
IDS_CANNOT_BUILD_SECTION_BY_WELL:'Невозможно построить разрез по скважине',
IDS_WELL_TRAJ_ONLY_POINT:'Невозможно построить разрез по скважине, т. к. ее траектория скважины содержит только одну точку',
IDS_SET_TRAJ_USING_DOUBLE_CLICKS:'Добавьте точки посредством серии двойных щелчков на карте',
IDS_PALETTE_COLOR_TABLE_SETTINGS:'Настройка цветовой шкалы',
IDS_PALETTE_VALUE:'Значение',
IDS_PALETTE_COLOR:'Цвет',
IDS_PALETTE_SMOOTH:'Непрерывная',
IDS_PALETTE_GRADUATED:'Дискретная',
IDS_PALETTE_DISCRETE:'Дискретная',
IDS_PALETTE_MIN:'Мин',
IDS_PALETTE_MAX:'Макс',
IDS_PALETTE_MINMAX_SOURCE:'Диапазон значений свойства',
IDS_PALETTE_MINMAX_CUSTOM:'Вручную',
IDS_PALETTE_MINMAX_ALL_CELLS:'По всем ячейкам',
IDS_PALETTE_MINMAX_VIS_CELLS:'По видимым ячейкам',
IDS_PALETTE_MINMAX_ALL_TIME:'По всем временным шагам',
IDS_PALETTE_MINMAX_CUR_TIME:'На текущий временной шаг',
IDS_PALETTE_RANGE:'Предельные значения',
IDS_PALETTE_MINMAX_AUTO:'Автоматические',
IDS_PALETTE_SPECIAL_COLORS:'Особые цвета за границами макс. и мин. значений',
IDS_PALETTE_COLORS:'Цвета',
IDS_PALETTE_ADD_COLOR:'Добавить цвет',
IDS_PALETTE_REMOVE_COLOR:'Удалить цвет',
IDS_PALETTE_FLIP:'Перевернуть цвета',
IDS_PALETTE_SET_REGULAR:'Распределить цвета равномерно',
IDS_PALETTE_APPEND_COLOR:'Добавить',
IDS_PALETTE_DELETE_COLOR: 'Удалить',
IDS_PALETTE_CHANGE_VALUE: 'Изменить значение',
IDS_PALETTE_CHANGE_COLOR: 'Изменить цвет',
IDS_PALETTE_INVERTED: 'Инвертировать',
IDS_PALETTE_SELECT_GAMMA:'Таблица цветов',
IDS_PALETTE_EDIT_MODE: 'Режим редактирования',
IDS_PALETTE_ACCURACY: 'Количество знаков после запятой',
IDS_PALETTE_DEFAULT: 'По умолчанию',
IDS_PALETTE_STEPS_NUM: 'Количество значений',
IDS_PALETTE_LEVELS:'Изолинии',

IDS_GAMMA_CUSTOM:'Пользовательская',
IDS_GAMMA_PHYSYCAL:'Физическая',
IDS_GAMMA_BLACK_RED_YELLOW:'Черно-красно-желтая',
IDS_GAMMA_RAINBOW:'Радуга',
IDS_GAMMA_BLACK_WHITE:'Черно-белая',

IDS_ISOLINE_COLOR:'Цвет',
IDS_AVE_PRESS_ANALYSIS:'Анализ среднего пластового давления',
IDS_AVE_PRESS_DESCR:'Среднее пластовое давление',
IDS_KH_DESCR: 'Проницаемость·толщина',
IDS_OIL_THICKNESS_DESCR: 'Нефтенасыщенная толщина',
IDS_EFFECTIVE_THICKNESS: 'Эффективные толщины',
IDS_DEPTH_DESCRIPTION: 'Глубина',

IDS_DEGREES:'\u00B0',
IDS_PERF_LEN:'Длина перфораций',
IDS_PERF_LEN_SHORT:'Длина перф.',
IDS_CURVE_RADUIS: 'Радиус кривизны',
IDS_DEL_FIRST_BRANCH_POINT_IS_NOT_ALLOWED:'Нельзя удалить точку врезки бокового ствола',
IDS_EDITOR_CHOOSE_OBJECT:'Выбор объекта',
IDS_EDITOR_MODE_MAINWELL:'Уплотняющее бурение',
IDS_EDITOR_MODE_BRANCH:'Боковой ствол',
IDS_WELL_PLACEMENT_PATTERN: 'Расстановка по шаблону',
IDS_PAGE_TITLE_WELL_SEARCH:'Подбор скважин',
IDS_CANNOT_ADD_BRANCH_TO_EMPTY_TRAJ:'Невозможно добавить боковой ствол к скважине, у которой отсутствует траектория',
IDS_CANNOT_DRAG_BRANCH_POINT_ON_SECT:'Чтобы изменить положение точки врезки на разрезе, перейдите в окно карт',
IDS_CANNOT_DRAG_BRANCH_POINT:'Не разрешается изменять положение точки врезки',
IDS_CANNOT_ADD_BRANCH_TO_BRANCH:'Невозможно добававить боковой ствол к боковому стволу',
IDS_CONFIRM_CHOOSE_TRAJ_MODE:'Невозможно добававить точку траектории. Включить режим редактирования траектории?',
IDS_WELL_CHARACTERISTICS:'Характеристика скважины',
IDS_TYPE_OF_WELL:'Тип',
IDS_RADIUS_OF_WELL:'Радиус',
IDS_SKIN_FACTOR:'Скин-фактор',
IDS_FUNCTION_NOT_IMPLEMENTED_YET:'Данная функция пока не реализована',
IDS_CANNOT_CALC_PROD_NO_PERF:'Невозможно произвести расчет, т.к. интервалы перфорации не заданы. Задайте интервалы перфорации в панели "Редактор перфораций"',
IDS_CANNOT_CALC_PROD_NO_PERF_CONDITIONS:'Невозможно произвести расчет. Задайте условия для интервалов перфорации в панели "Настройки расчета"',
IDS_SHOW_TOOLTIP_TVD_MD:'Подсказка TVD, MD',
IDS_SECTION_PLANES:'Плоскости разреза',
IDS_WELL_APPEND_POINT:'Добавить',
IDS_WELL_INSERT_POINT:'Вставить',
IDS_WELL_DELETE_POINT:'Удалить',
IDS_CALC_PERIOD_MONTH:'месяц',
IDS_CLEAR:'Очистить',
IDS_DELETE_SWEET_SPOT:'Удалить точку',
IDS_CREATE_WELL_BY_SWEET_SPOT:'Создать скважину',
IDS_CALC_WELL_PLACEMENT:'Расчет местоположения скважин...',
IDS_EFFICIENCY:'Эффек\xADтив\xADность',
IDS_RATE_START:'Начальный дебит нефти',
IDS_RATE_FINISH:'Конечный дебит нефти',
IDS_WELL_PLACEMENT_BHP_GREATER_AVE_PRESSURE:'Забойное давление выше среднего давления по модели. Запустить расчет?',
IDS_WELL_PLACEMENT_BAD_SMALLER_BUBBLE_POINT_PRESSURE:'Забойное давление ниже давления насыщения. Запустить расчет?',
IDS_WELL_PLACEMENT_STEP_X:'Шаг по x',
IDS_WELL_PLACEMENT_STEP_Y:'Шаг по y',
IDS_RATE_CALCULATION:'Дебит нефти Расчет',
IDS_RATE_EVALUATION:'Дебит нефти Оценка',
IDS_WELL_PLACEMENT_RESULT:'Результаты расчета',
IDS_RATE:'дебит',
IDS_TIME:'время',
IDS_OBJECTS_TREE:'Дерево объектов',
IDS_MAP:'Карта',
IDS_SELECTING_LOW_FORMATION_PRESS_ZONE:'Выделение области пониженного давления',
IDS_PRESS_PLUS_FOR_SELECTING_LOW_FORMATION_PRESS_ZONE:'<p>Нажмите на кнопку "<b>+</b>" для выделения области пониженного давления или ',
IDS_FOR_EDITING_OF_EXIST_ZONE:'для редактирования существующей области.</p>',
IDS_WELL_LIST:'Список скважин',
IDS_PROD_WELL_LIST:'Список добывающих скважин',
IDS_PROD_WELLS_WILL_BE_SEELCTED:'<p>После того, как будет определена область пониженного давления, в этом списке выделятся добывающие скважины, находящиеся в заданной области.</p>',
IDS_AVAILABLE_FILTER_LIST:'Настройки расчета',
IDS_FILTERS_USE_DB_INFO:'<p>Фильтры используют промысловую информацию, взятую из соответствующего источника</p>',
IDS_WELL_STATE_TABLE:'Нагнетательные скважины',
IDS_SHOWS_ALL_INJ_WELLS_STATE:'<p>В этой таблица отображается состояние всех нагнетательных скважин.</p>',
IDS_BY_DEFAULT_PRESS_MAP_SHOWN_RELATIVE_TO_INIT_VALUE:'<p>По умолчанию  показывается карта изменения пластового давления относительно начального значения</p>',
IDS_REGION_POINTS:'Точки региона',
IDS_NO_POINTS_IN_REGION:'В заданном регионе нет точек!',
IDS_REGION_POINTS_WARNING:'Граница региона должна иметь более 2х точек!',
IDS_CONVERTED_WELLS:'Переведенные скважины',
IDS_NO_CONVERTED_WELLS:'Нет ни одной переведенной скважины!',
IDS_NO_AIR_ACCESS:'Функции AIR на сервере не доступны',
IDS_NO_WRITE_ACCESS:'У вас нет прав для изменения данных',
IDS_ERROR_RECEIVING_DIAGRAM:'Ошибка при получении диаграммы<p>',
IDS_NO_CONNETION_TO_SERVER:'Нет соединения с сервером <b>ПроПласт</b>',
IDS_NO_DATA_SPECIFIED_WELL:'Нет информации по данной скважине<p>&nbsp;',
IDS_SERVER_RETURN_ERROR:'Сервис <b>ProPlast Data Storage</b> вернул ошибку:<p>',
IDS_WELL_NOT_FOUND:'Скважина не найдена',
IDS_RESET_FILTER:'Сбросить фильтр',
IDS_CREATE_TRAJ:'Создать траекторию',
IDS_CALC_SETTINGS:'Настройки расчета',
IDS_TRACERS:'Трассеры',
IDS_SIMULATION_OF_TRACERS_INJECTION:'Моделирование закачки трассеров',
IDS_LOW_FORMATION_PRESSURE_ZONES:'Области пониженного давления',
IDS_PROD_DATA_FILTER:'Фильтр по промысловым данным',
IDS_MODEL_DATA_FILTER:'Фильтр по модельным данным',    
IDS_PROD_DATA_OIL_FILTER:'Фильтр по добыче нефти',
IDS_WATER_FLOODING_OPTIMIZATION:'Оптимизация ППД',
IDS_OPTIMIZATION:'Оптимизация',
IDS_REGION:'Регион',
IDS_INTERFERENCE_COEF:'Коэффициенты взаимовлияния',
IDS_INJ_WELLS:'Нагнетательные скважины',
IDS_PROD_WELLS:'Добывающие скважины',
IDS_TRANSITION:'Перевод в нагнетание',
IDS_TRANSITION_CANDIDATES:'Кандидаты для перевода',
IDS_TRANSITION_OF_PROD_WELLS:'Перевод скважин',
IDS_CHOOSE_MODEL_TO_EXPORT_OF_WELL:'Выберите модель, в которую надо экспортировать скважину',
IDS_CHOOSE_MODEL_TO_IMPORT_OF_WELL:'Выберите модель, из которой надо импортировать скважину',
IDS_LOAD_AVAIBLE_WELL_LIST:'Загрузить список доступных скважин...',
IDS_CREATING_OF_REGION:'Создание региона',
IDS_SWEEP_AREA:'Площадь завод\xADнения',
IDS_CONVERT_WELL:'Перевести в нагнетание',
IDS_BACK_TO_SETTINGS:'Вернуться к настройкам',
IDS_LIQ_PROD_TO_BASE:'Изменение добычи нефти и жидкости относительно базового варианта',
IDS_CASE_DETAILS:'Детализация по варианту',
IDS_CASE_SUMMARY:'Интегральные характеристики по варианту',
IDS_INIT_PRESS:'Начальное давление',
IDS_TRACERS_INFO:'Расчет Трассеров',
IDS_TRACERS_RESULTS:'Результаты расчета трассеров',
IDS_WELLS_FILTER:'Фильтр по скважинам',
IDS_WELLBORE_LEAKAGE:'Скважины с негерметичностью колонны',
IDS_BOTTOM_HOLE_DZ:'Скважины с загрязненной призабойной зоной',
IDS_INEFFECTIVE_INJ:'Скважины с неэффективной закачкой',
IDS_WELL_STATUS:'Классификация скважин',
IDS_WELL_STATUS_NO_DATA: 'Нет данных', //'Нет данных по данной скважине',
IDS_OPTIMAL_CONDITIONS:'Оптимальные характеристики',
IDS_SUB_OPT_CONDITIONS:'Недостаточно оптимальные характеристики',
IDS_OPT_NOT_RECOMMENDED:'Скважина не подлежит оптимизации',
IDS_USER_SET_STATUS:'Класс выставлен пользователем',
IDS_WELLBORE_LEAKAGE_SHORT:'Негерме\xADтичность колонны',
IDS_BOTTOM_HOLE_DZ_SHORT:'Загряз\xADнение ПЗП',
IDS_INEFFECTIVE_INJ_SHORT:'Неэффек\xADтивная закачка',
IDS_WELL_STATUS_INFO:'Статус',
IDS_TRACERS_TEST_RESULTS:'Эффек\xADтив\xADность по трассерам',
IDS_HYDRAULIC_STRUCT_PRESS:'Давление авто-ГРП',
IDS_TOOLTIP_MIN_DIST:'мин.расст.',
IDS_TOO_CLOSE_TO_ANOTHER_WELL_1:'Расстояние от ствола до скважины',
IDS_TOO_CLOSE_TO_ANOTHER_WELL_2:' меньше допустимого',
IDS_TOO_CLOSE_TO_FAULT_1: 'Расстояние до разлома ',
IDS_BHP_GRTHEN_RESERVOIR_PRESS:'Забойное давление выше пластового',
IDS_NO_PERF_BY_FILTER:'Не удовлетворено условиям фильтра на перфорации',
IDS_ECONOMICAL_EVALUATION:'Эконо\xADми\xADческая оценка',
IDS_TRANSITION_NO_CANDIDATES_YET:'Кандидаты для перевода еще не рассчитаны',
IDS_TRANSITION_SOME_CANDIDATES_CONVERTED:'Некоторые скважины уже были переведены',
IDS_TRANSITION_ALL_CANDIDATES_CONVERTED:'Все скважины уже были переведены',
IDS_RMS_PROJECT:'Путь к модели',
IDS_FILTERS_CAPTION: 'фильтры',
IDS_NUMERICAL_SETTINGS: 'Настройки численного метода',
IDS_UNCERTAINTIES_CALCULATION: 'Расчет неопределенностей',
IDS_USING_UNCERTAINTIES: 'Учет неопределенностей',
IDS_AUTO_PRESS_MAINTANCE: 'Поддерживать пластовое давление',
IDS_NO_FILTERS_SELECTED:'Не отмечено ни одного фильтра',
IDS_SERACHING_IN_DATABASE:'Поиск в источнике промысловой информации',
IDS_WELLS_FOUND:'Найдено скважин',
IDS_WELLS_FOUND_WITH_LEAKS:'\r\n<br> &nbsp;&nbsp;&nbsp; с негерметичностью колонны: <b>',
IDS_WELLS_FOUND_CONTAMINATED:'\r\n<br> &nbsp;&nbsp;&nbsp; с загрязненной призабойной зоной: <b>',
IDS_WELLS_FOUND_INEFFECTIVE:'\r\n<br> &nbsp;&nbsp;&nbsp; с неэффективной закачкой: <b>',
IDS_CONFIRM_CLEAR_WELL_PLACEMENT:'Вы действительно хотите очистить таблицу?',
IDS_NO_BINDING_DATABASE:'Промысловая информация не доступна, так как нет привязки к ее источнику.\r\nСделайте привязку в модуле управления проектами.',//на странице выбора модели',
IDS_NO_BINDING_FIELD:'Промысловая информация не доступна, так как нет привязки к месторождению.\r\nСделайте привязку в модуле управления проектами.',// на странице выбора модели',
IDS_NO_BINDING_RESERVOIRES:'Промысловая информация не доступна, так как нет привязки к эксплуатационному объекту.\r\nСделайте привязку в модуле управления проектами.',// на странице выбора модели',
IDS_NO_BINDING_MODEL:'Промысловая информация не доступна, так как нет привязки к двумерной модели.\r\nСделайте привязку в модуле управления проектами.',// на странице выбора модели',
IDS_USER:'Пользователь',
IDS_CHANGE:'Изменение',
IDS_OPTION3D_VISUALIZATION:'Визуализация',
IDS_INTERFACE:'Интерфейс',
IDS_STATISTICS:'Статистика',
IDS_WELL_CHARTS:'Графики по скважинам',
IDS_CONTOUR_SMOOTHING:'Сглаживание линий',
IDS_COLOR_POINTS_BY_Z:'Color points by Z',
IDS_COLOR_FAULTS_BY_Z:'Color faults by Z',
IDS_WELL_TRAJECTORIES:'Траектории скважин',
IDS_MIN_DISTANCE_BETWEEN_WELLS:'Расстояние до существующих скважин более',
IDS_OTHER:'Другие',
IDS_WELL_DIAGNOSTIC:'Диагностика скважин',
IDS_FOR_SET_PERIOD:'за период',
IDS_PERFS_IN_FLOW_GRID:'Интервалы перфораций на расчетной сетке',
IDS_WELLVIEW_SCALE:'Масштаб',
IDS_WELLVIEW_TEMPLATE:'Шаблон',
IDS_CALC_WELL_PLACEMENT_VARIANTS:'Рассчитать',
IDS_NO_PROP_CHECKED:'Ни одного свойства не выбрано',
IDS_NOTHING_IS_SELECTED_FOR_IMPORT:'Ничего не выбрано для импорта',
IDS_NO_PRESSURE_PROPERTY_FOUND:'Свойство PRESSURE не найдено',
IDS_NO_PROJECTS_LOADED_INTO_RV:'В ProPlast не загружен ни один проект',
IDS_NO_PROJECTS_LOADED_INTO_TEMPEST:'В Tempest не загружен ни один проект',
IDS_TO_TEMPEST: 'В TEMPEST',
IDS_TO_EXCEL: 'В EXCEL',
IDS_HIST_ANALYSIS_SETT: 'Настройки расчетного метода - Анализ данных',
IDS_NO_RUNS_IN_THE_TEMPEST_PROJECT: 'Ни одного расчета в проекте TEMPEST',
IDS_INFO_THERE_IS_NO_CALCULATD_VARIANTS:'Отсутствуют рассчитанные варианты!!!',
IDS_DO_YOU_WANT_KEEP_CURRENT_SESSION:'Вы хотите остаться в текущей сессии? Ответ "Нет" или закрытие диалога приведет к отрытию новой сессии.',
IDS_COULD_NOT_SAVE_EMPTY_TRAJECTORY_OR_NO_WELL_SELECTED:'Невозможно сохранить пустую траекторию. Возможно ни одна скважина не выбрана',
IDS_ERROR_GENERATIONG_TRAJECTORY:'Ошибка записи траектории',
IDS_ERROR_GENERATIONG_PERFORATIONS:'Ошибка записи перфораций',
IDS_COULD_NOT_GENERATE_RESULT_FILE:'Ошибка записи результата',
IDS_CHOOSE_WELLS_FOR_TRACERS_CACLULATION:'Выберите скважины для рассчета трассеров!',
IDS_NO_INJ_WELL_SELECTED:'Расчет не возможен, т.к. ни одной нагнетательной скважины не выделено в таблице',
IDS_NO_PROD_WELL_SELECTED:'Расчет не возможен, т.к. ни одной добывающей скважины не выделено в таблице',
IDS_RETURN_TO_PRODUCER:'Вернуть',
IDS_NO_WELL_SELECTED_FOR_CONVERSION:'Ни одной скважины не отмечено для перевода',

IDS_NO_HOR_PROP_FOR_MAP: 'Отсутствует свойство для выбранной карты',
IDS_UNKNOWN_MAP: 'Неизвестная карта',
IDS_WELLSRANG_WINDOW_NAME:'Оптимизация закачки',
IDS_CURRENT_DATE: 'Текущая дата',
IDS_TVD: 'Глубина',
IDS_PERF_CONDITIONS_CHANGED:'Условия для расчета интервалов перфорации новых скважин изменены. Нажмите кнопку "Рассчитать", чтобы обновить результат',
IDS_PERF_CONDITIONS_WILL_BE_APPLIED: 'Условия для расчета интервалов перфорации новых скважин изменены. Для того, чтобы их применить, нажмите кнопку "Рассчитать"',
IDS_SET_DEFAULT_VALUES: 'По умолчанию',
IDS_CREATE_REGION: 'Создать регион',
IDS_CREATE_REGION_BY_VISIBLE_CELLS : 'Создать регион по видимым ячейкам',
IDS_NEW_REGION: 'Регион1',
IDS_CONFIRM_CLEAR_EDITOR_CALC_RESULTS:'Изменение даты приведет к потере рассчитанных данных. Вы действительно изменить дату?',
IDS_SWEET_SPOT_STATUS: 'Классификация скважин',
IDS_SWEET_SPOT_UNKNOWN: 'Неизвестно',
IDS_SWEET_SPOT_STATUS_LOW_RISKS: 'Низкие риски',
IDS_SWEET_SPOT_STATUS_MIDDLE_RISKS: 'Средние риски',
IDS_SWEET_SPOT_STATUS_HIGH_RISKS: 'Высокие риски',
IDS_SWEET_SPOT_RISK_SETTINGS: 'Настройки критериев рисков',
IDS_SWEET_SPOT_EVALUATE_DIST_TO_FAULTS: 'Оценивать расстояние до разломов',
IDS_SWEET_SPOT_DIST_TO_FAULTS: 'Допустимое расстояние до разломов',
IDS_SWEET_SPOT_PROFITABILITY_LEVEL: 'Порог рентабельности',
IDS_REGION_DELETE: 'Удалить регион',
IDS_CONFIRM_CREATE_REGION_AFTER_APPLIED_FILTERS: 'Создать регион по выбранным параметрам?',
IDS_REGION_CREATED: 'Создан регион',
IDS_CANNOT_CHANGE_DATE_ON_TRACERS_MODEL_VIEWER: 'Для изменение даты начала расчета выберите другой пункт из меню "Действие"',
IDS_PREVIEW: 'Предпросмотр',
IDS_APPLY_FILTER:'Применить',// фильтр',
IDS_ERROR_APPLY_FILTER: 'Перед применением фильтра необходимо изменить его параметры',
IDS_FC_RESET_FILTER: 'Сбросить',// фильтр',
IDS_MAP_ACTIONS: 'Карты',
IDS_ERROR_CREATE_REGION: 'Перед созданием региона необходимо изменить параметры',
IDS_MODEL_STAT: 'По модели',
IDS_WELLS_STAT: 'По скважинам',
IDS_MULTIVARIANT_CALCULATION_SETTINGS: 'Настройки',
IDS_MULTIVARIANT_CALCULATION_SETTINGS_EXTRA: 'Дополнительно',
IDS_MULTIVARIANT_CALCULATION_ENABLE: 'Сразу провести расчет неопределенностей',
IDS_WELL_SEARCH_SETTINGS_WELL_PARAMS: 'Параметры скважин',
IDS_WELL_SEARCH_SETTINGS_PERF_PARAMS: 'Настройки перфораций',
IDS_WELL_SEARCH_SETTINGS_PERF_FILTERS: '{numProps, plural, =0 {По всей длине скважины} =1 {Примененный фильтр: } other {Примененные фильтры (#): }}{props}',
IDS_WELL_NO_GO_ZONE_FILTERS: '{numProps, plural, =0 {Без ограничений>: } =1 {Примененный фильтр: } other {Примененные фильтры (#): }}{props}',
IDS_SWEETSPOT_DISTANCE_TO_FAULT: 'Расстояние до разлома',
IDS_SWEETSPOT_DETAILS_STATUS_BREAKDOWN_HEADER: 'Классификация',
IDS_MULTIVARIANT_CALCULATION_PERFORM: 'Рассчитать',
IDS_MULTIVARIANT_CALCULATION_PERFORMED_CONDITIONS: 'Рассчитывать только для рентабельных',
IDS_MULTIVARIANT_CALCULATION_WARN_NO_SINGLE_YET: 'Для расчета неопределенности дебита проведите базовый расчет, нажав кнопку "Рассчитать" во вкладке "Действия"',
IDS_MULTIVARIANT_CALCULATION_WARN_NO_WELLS_SATISFY_CONDITIONS: 'Нет скважин удовлетворяющих заданным условиям.',
IDS_PAGE_TITLE_KH:'Карта kh',
IDS_PAGE_TITLE_OIL_THICKNESS:'Нефтенасы\xADщенные толщины',//'Карта нефтенасы\xADщенных толщин',
IDS_INDEX_BY: 'Индекс по',
IDS_COORDS_BY: 'Координаты по',
IDS_CANNOT_BE_APPLIED_FILTER: 'Фильтр по длине ствола не будет применен',
IDS_CHOOSE_ENTRY_POINT: 'Зафиксировать точку входа в пласт',
IDS_DISTANCE_TO_SWEETSPOT: 'Расстояние до T1',

IDS_SYMBOL_TRAJ_POS: 'Положение символа скважины',
IDS_SYMBOL_TRAJ_POS_HEAD: 'Устье',
IDS_SYMBOL_TRAJ_POS_BOTTOM: 'Забой',
IDS_SYMBOL_TRAJ_POS_WELLPICK: 'Пластопересечение',

IDS_CANNOT_BUILD_BRANCH_TO_SWEET_SPOT_SIDETRACKING_ANGLE_EXCEEDED: 'Невозможно построить боковой ствол от данной скважины к указанной точке. Превышен допустимый угол отхода в точке врезки',
IDS_CANNOT_BUILD_BRANCH_TO_SWEET_SPOT_TRAJECTORY_ENTIRELY_IN_RESERVOIR: 'Невозможно врезать боковой ствол для данной скважины, т.к. ее траектория целиком лежит внутри пласта',
IDS_CANNOT_BUILD_BRANCH_TO_SWEET_SPOT_TRAJECTORY_OUT_OF_GRID: 'Невозможно врезать боковой ствол для данной скважины, т.к. ее траектория целиком лежит вне пласта',
IDS_CURVE_LENGTH_EXCEEDED: 'Длина кривой превышает допустимое значение. Длина = ',
IDS_CURVE_CURVATURE_EXCEEDED: 'Максимальная кривизна кривой превышает допустимое значение. Радиус кривизны = ',
IDS_BRANCH_TAIL_ANGLE: 'Азимут',
IDS_IN_INTERVAL: 'В интер\xADвале',
IDS_OUTSIDE_INTERVAL: 'Вне интер\xADвала',
IDS_WELLS_LOW_PRODUCTIVITY: 'Низкодебитные',
IDS_WELLS_HIGH_PRODUCTIVITY: 'Высокодебитные',
IDS_WELLS_LEAKY: 'Негерметичные',
IDS_TRESHOLD_VALUE_OF_DEBIT: 'Рентабельное значение дебита', //'Пороговое значение дебита',
IDS_INTERVAL: 'Интервал',
IDS_HYDRAULIC_FRACTURING: 'Гидроразрыв пласта',
IDS_HYDRAULIC_FRACTURING_ABBREVIATION: 'ГРП',
IDS_PLUGIN_LAUNCHED: 'Программа выполнена',
IDS_PLUGIN_ERROR_LAUNCHED: 'Ошибка при запуске программы',
IDS_USER_PLUGINS: 'Пользовательские макросы',
IDS_BASE_PLUGINS: 'Базовые макросы',

IDS_SHOW_HIDE_ALL_WELL_LABELS: 'Скрыть перекрывающиeся номера скважин',
IDS_RUN: 'Запустить',
IDS_CURVES_NUMBER: 'Количество траекторий',
IDS_AVERAGE_VALUE: 'Среднее значение',
IDS_DEVIATION: 'Стд. отклонение',
IDS_PRODUCTION_WELL: 'Добывающая скважина',
IDS_INJECTOR_WELL: 'Нагнетательная скважина',
IDS_TO_WELLS: 'до существующих скважин',
IDS_NORMAL_DISTR: 'Нормальное',
IDS_SKO: 'СКО',
IDS_LOGNORMAL_DISTR: 'Логнормальное',
IDS_TRIANGLE_DISTR: 'Треугольное',
IDS_KD: 'К.д.',
IDS_DISTRIBUTION_FUNCTION: 'Тип распределения',
IDS_STD_DEVIATION: 'Среднее квадратическое отклонение',
IDS_CORR_LENGTH: 'Корреляционная длина',
IDS_MINIMAL: 'Минимальное значение',
IDS_MAXIMAL: 'Максимальное значение',
IDS_RESERVOIR_THICKNESS: 'Толщина пласта',
IDS_DECIMAL_QUANTITY: 'д.е.', // доли единицы
    IDS_ALL_WELLS: 'Все скважины',
    IDS_PIEZOMETRIC_WELLS: 'Пьезометрические скважины',
IDS_CALC_ANALYSIS: 'Анализ расчета',
IDS_UNCERTAINTIES: 'Выбрать параметры неопределенности',
IDS_NO_DATA_SPEARMAN_ANALYS: 'Нет данных для проведения сравнительного анализа. Необходимо провести расчет.',
IDS_NO_DATA_INJWELL_INFLUENCE: 'Нет рассчитанных данных. Необходимо провести расчет.',
//IDS_2DPLUS_CALCULATIONS: '2D+ модель',
IDS_2DPLUS_CALCULATIONS: 'Модель с упрощенной физикой',
IDS_ANALYTICAL_EXPR: 'Аналити\xADчес\xADкие оценки',
IDS_FIELD_DATA_ANALYSIS: 'Анализ данных',
IDS_CORRELATION_FACTOR: 'Коэффициент корреляции',
IDS_SPEARMAN_CORRELATION: 'Корреляция (метод Спирмена)',
IDS_EQ_METHODS: 'Сравниваемые методы',
IDS_INITIAL_RATE : 'Стартовые показатели',
IDS_NEIGBOURS_STARTING_DEBITS: 'Начальные дебиты соседних скважин',
IDS_COEFFICIENT: 'Коэффициент влияния на добычу',
IDS_LIQUID_COEFF: 'по жидкости',
IDS_OIL_COEFF: 'по нефти',
IDS_INFLUENCE_COEFF: 'Коэффициенты влияния',
IDS_WELL_PROPERTIES: 'Показатели',
IDS_NO_SHUT_WELLS_IN_OILSATZONE: 'Нет добывающих скважин в нефтенасыщенной зоне',
IDS_NO_SHUT_WELLS_IN_MODEL: 'Нет добывающих скважин в модели',
IDS_NO_PROD_WELLS_IN_OILSATZONE: 'Нет добывающих скважин в нефтенасыщенной зоне',
IDS_NO_PROD_WELLS_IN_MODEL: 'Нет добывающих скважин в модели',
IDS_NO_INJ_WELLS_IN_OILSATZONE: 'Нет нагнетательных скважин в нефтенасыщенной зоне',
IDS_NO_INJ_WELLS_IN_MODEL: 'Нет нагнетательных скважин в модели',
IDS_PAGE_TITLE_WELLPLACE_SIDETRACK: 'Оценка местоположения бокового ствола',
IDS_PERC_OF_POINTS_TOO_CLOSE : '% точек расположено слишком близко к другим скважинам',
IDS_PERC_OF_POINTS_HIGH_BHP : '% точек с забойным давлением выше пластового',
IDS_PERC_OF_POINTS_NO_PERF : '% точек не удовлетворили условиям фильтра на перфорации',
IDS_PERC_OF_POINTS_FILTER_HOR_PROP : '% точек не удовлетворили условиям области поиска',
IDS_PERC_OF_POINTS_RESERVES : '% точек не удовлетворили условиям области поиска: плотность мобильных запасов',
IDS_PERC_OF_POINTS_AV_PRES : '% точек не удовлетворили условиям области поиска: среднее пластовое давление',
IDS_MILLI_METERS: 'мм',

IDS_APPLY_PALETTE:'Изменение цветов',

IDS_MODEL_SUCESSEFULLY_CALCULATED: 'Расчет успешно завершен',
IDS_MODEL_SUCESSEFULLY_RECALCULATED: 'Модель успешно пересчитана',

IDS_MACRO_WITH_THAT_NAME_ALREADY_EXIST: 'Макрос с таким названием уже существует',
IDS_MACRO_TEXT_INPUT_FIELD: 'Поле для ввода текста макроса',
IDS_ENTER_MACRO_TEXT: 'Введите текст макроса',
IDS_SELECT_FUNCTION: 'Выберите функцию',
IDS_FUNCTION_DESCRIPTION: 'Описание функции',
IDS_INSERT_FUNCTON: 'Вставить функцию',
IDS_DELETE_MACRO: 'Удалить макро?',
IDS_CREATE_NEW_MACRO: 'Создать новый макро',
IDS_MACRO_EDITOR: 'Редактор макросов',
IDS_RULES: 'Правила написания',
IDS_EXAMPLE: 'Пример',
IDS_EXIT_FROM_MACROEDITOR_WITHOUT_CHANGES_DIALOG: 'Выйти из редактора без сохранения изменений?',
IDS_DELTA_INJ: 'Изменение закачки',
IDS_PROD_INCREASE : 'Изменение добычи нефти',
IDS_LIQUID_INCREASE: 'Изменение добычи жидкости',
IDS_BUILD_WELL_BRANCH: 'Построить боковой ствол',
IDS_PARAMETER: 'Параметр',
IDS_ACCURACY: 'Точность',
IDS_LIMIT_VALUES: 'Предельные значения',
IDS_COUNTOUR_LINES_STEP: 'Шаг изолиний',
IDS_GENERAL_SETTINGS: 'Общие настройки',
IDS_BUILDING_OF_WELL_BRANCH: 'Построение бокового ствола...',
IDS_EVALUATING_OF_WELL_BRANCH: 'Расчет бокового ствола...',
IDS_SHUT_WELLS: 'Остановленные скважины',
IDS_MODEL_IN_QUEUE_1: 'Модель <br>',
IDS_MODEL_IN_QUEUE_2: '<br>поставлена в очередь на расчет\r\n<br>Посмотреть очередь?',

IDS_SELECT_MODEL_TO_IMPORT_INTO: 'Выберите модель, в которую экспортировать',
IDS_SELECT_MODEL_FOR_IMPORT: 'Выберите скважины для импорта',
IDS_WAIT_PLUGIN_TO_FINISH: 'Подождите окончания работы плагина, запущенного в отдельном окне.\r\n<br>Не загружайте, пожалуйста другую модель в этой вкладке браузера.',

IDS_WELLS_CONVERSION_FILTER: 'Фильтр',
IDS_DIST_SS_TO_WELL: 'Отход',
IDS_DIST_SS_TO_WELL_FULL: 'Длина отхода',
IDS_DIST_WELL_TO_SWEET_SPOT_EXCEED_LIMIT: 'Превышен отход от скважины',
IDS_DIST_TO_WELL_TOO_SMALL: 'Расстояние от ствола до других скважин меньше допустимого',
IDS_WELL_TRAJ_TRUNCATED: 'Отсутствует информация о траектории выше пласта',
IDS_WELL_HAS_NO_TRAJECTORY: 'Скважина не имеет траектории',
IDS_WELL_CURVE_HOOK_TYPE: 'Траектория имеет U-образную форму',
IDS_CURVE_RADIUS_EXCEED: 'Радиус кривизны меньше допустимого значения (687 м)',
IDS_SIDE_TRACK_LENGTH_EXCEED: 'Длина бокового ствола превышает максимально допустимое значение',
IDS_CURVE_RADIUS: 'Радиус кривизны',
IDS_CURVE_ERR_UNKNOWN: 'Неизвестная ошибка при расчете кривой',
IDS_DIST_EXCEEDED_SHORT: 'Превышен отход',
IDS_DIST_TO_WELL_TOO_SMALL_SHORT: 'Близко к скважине',
IDS_NO_TRAJ: 'Нет траектории',
IDS_BRANCH_NOT_CHOSEN: 'Кликните диапазон, затем выберите на графике точку, соответствующую одной из траекторий',
IDS_USERDEFINED_PERFORATION: 'Задана пользователем',
IDS_WELLS_TO_SWEETSPOT_DISTANCE_CALCULATING: 'Вычисляется расстояние от скважин до точки...',
IDS_OF: 'из',
IDS_WELL: 'Сква\xADжи\xADна', // see also IDS_WELL3D
IDS_SEARCH: 'Поиск',
IDS_NOTHING_FOUND: 'Ничего не найдено',
IDS_PROP_NAME: 'Имя св-ва',
IDS_CREATE_WELL_GROUP: 'Создать группу скважин',
IDS_TECHNOLOGICAL_PARAMETERS: 'Технологические показатели',
IDS_TYPES: 'Типы',
IDS_ACTIVITIES: 'Мероприятия',
IDS_DISTANCE_TO_OWC: 'Расстояние до ВНК более',
IDS_DISTANCE: 'Параметр шаблона',//'Рассто\xADяние',
IDS_GO_ZONE: 'Зона интересов',
IDS_NOT_GRATER_THAN: 'Не более',
IDS_TRAJ_CHANGED_CANNOT_OPTIMIZE: 'Не возможно произвести расчет оценки рисков, так как траектория ствола была изменена',
IDS_SIDE_TRACKING_ANGLE_SHORT: 'Угол отхода',
IDS_SIDE_TRACKING_UPSHIFT_SHORT: 'Высота точки врезки',
IDS_BHP_UNCHANGEABLE: 'Значение забойного давления взято из модели. Изменение его невозможно',
IDS_CHANGING_PERF_PROHIBIT_FOR_MODEL_WELL: 'Скважина загружена из модели. Изменение ее интервалов перфораций невозможно',
IDS_CHANGING_TRAJ_PROHIBIT_FOR_MODEL_WELL: 'Скважина загружена из модели. Изменение ее траектории невозможно',
IDS_CHANGING_TRAJ_PROHIBIT_FOR_TRAJ_IJK: 'Отсутствует реальная xyz-траектория для данной скважины. Изменение ее траектории невозможно',
IDS_SWEET_SPOT_NOT_DEFINED: 'Не выбрана точка входа в пласт. Зафиксируйте ее в "Оценке местоположения бокового ствола"',
IDS_NO_GO_ZONE_CONDITIONS_CHANGED: 'Условия для области поиска новых скважин изменены. Нажмите кнопку "Рассчитать", чтобы обновить результат',
IDS_NO_GO_ZONE_SETTINGS: 'Область поиска',
IDS_NO_GO_ZONE_HEADER: 'Область поиска',
IDS_MODULE_OPTIMIZE_MODELS: 'Оптимизация разработки',
IDS_MODULE_BROWSE_MODELS: 'Анализ 3D моделей',
IDS_MODULE_PROJECT_MANAGER: 'Менеджер проектов',
IDS_MODULE_EDIT_MODELS: 'Оптимизация положения скважин',
IDS_MODULE_RUN_MACRO: 'Макросы и плагины',
IDS_TRAJECTORY_PARAMS: 'Параметры траектории',
IDS_SIDETRACK_CREATED_MANUALLY: 'Боковой ствол создан вручную либо был отредактирован',
IDS_CANNOT_CALC_PROD_DISTRIBUTION: 'Расчет распределения продуктивности невозможен',
IDS_SIDETRACK_TAIL_LENGTH: 'Длина от точки T1',
IDS_PERFORATIOS_WILL_BE_LOST: 'Существующие интервалы перфорации будут потеряны. Продолжить?',
IDS_FILTER: 'filter',
IDS_FORMATION_PRESSURE: 'Пластовое давление',
IDS_CALCULATING_PRESSURE_BUBBLE_POINT: 'Вычисление давления насыщения...',
IDS_ANTICLINE_TRAP: 'Пластово-сводовый',
IDS_MASSIVE_RESERVOIR: 'Массивная залежь',
IDS_ISOLATED_TRAP: 'Изолированный пласт',

IDS_SOME_PERFS_CHANGED: 'Некоторые интервалы перфорации изменены вследствие изменения траектории скважины',
IDS_INVALID_SPOT_STEP: 'Недопустимое значение шага',
IDS_UNABLE_PROD_FORECAST: 'Расчет невозможен. Скважина не является добывающей',

IDS_SDM_ERR_OUT_OF_OIL_SAT_ZONE: 'Перфорация данной скважины находится вне текущего региона',
IDS_SDM_ERR_OUT_OF_OIL_SAT_ZONE_TRJ: 'Траектория данной скважины находится вне текущего региона',
IDS_FILTRATION_INF_ONE_CELL_SHUT: "Скважина находится в пределах той же ячейки, что и другая работающая скважина",
IDS_SDM_ERR_OUT_OF_DATA_VARIANT: 'Перфорация данной скважины находится вне варианта данных',

IDS_SDM_ERR_RESERVES_FILTER: 'Отфильтровано по области поиска: плотность подвижных запасов',
IDS_SDM_ERR_AV_PRES_FILTER: 'Отфильтровано по области поиска: среднее пластовое давление',
IDS_TO_ADD_NEW_SWEET_SPOT_CLICK_MAP: 'Добавьте целевую точку посредством двойного щелчка по карте',
IDS_NO_GO_ZONE_COMPUTATION: 'Вычисление области поиска',
IDS_DAYS: 'дни',
IDS_RESERVES_INIT: 'Извлекаемые запасы',
IDS_RESERVES_FILTER_AV_PRESS: 'Запасы в зоне пониженного давления',
IDS_OFFER_WFO: 'извлекаемых запасов находится в зоне пониженного давления. Предлагается перед расчетом провести ППД. Запустить расчет без ППД?',
IDS_REGION_STATISTICS_COMPUTATION: 'Вычисляется статистика по региону',
IDS_CANNOT_SHOW_NO_GO_ZONE_ON_STRUCT: 'Невозможно отобразить область поиска на структурной карте',
IDS_CANNOT_SHOW_NO_GO_ZONE_ON_HORIZON: 'На данной карте область поиска не применима',
IDS_VISCOSITY_SETTINGS: 'Вязкость флюида',
IDS_BOUNDARY_PRESSURE: 'Давление на границах пласта',
IDS_BOUNDARY_PRESSURE_TOLERANCE: 'допуск',
IDS_NO_2D_GRID_IN_RDS_MODEL: 'В выбранном источнике промысловой информации отсутствует двумерная модель. Выберите другой источник данных или подготовьте текущий.',
IDS_2D_GRID: 'Сетка 2D',
IDS_NO_DATE_CHOOSEN: 'Не выбрана дата мероприятия',
IDS_CANNOT_CALC_INJ_WELL:          "Выбранная скважина является нагнетательной. Расчет прогноза добычи невозможен",
IDS_CANNOT_CALC_SHUT_WELL:         "Выбранная скважина является выбывшей. Вы действительно хотите продолжить расчет?",
IDS_CANNOT_CALC_STOP_WELL:        "Выбранная скважина является остановленной. Расчет прогноза добычи невозможен?",
IDS_CANNOT_CALC_GAS_WELL:          "Выбранная скважина является газовой. Вы действительно хотите продолжить расчет?",
IDS_CANNOT_CALC_UNKNOWN_WELL:      "Выбранная скважина имеет неизвестный тип. Вы действительно хотите продолжить расчет?",
IDS_STOPPED_WELL: "Остановленная",
IDS_FILTERS_APPLIED_TO_REGION: 'Фильтры применяются к региону ',
IDS_EDITING_PROHIBITED_WRONG_MODE: 'Для редактирования скважины включите режим редактирования траектории или редактирования перфораций.',
IDS_EDITING_PROHIBITED_WELL_MODE_BRANCH_SELECTED: 'Редактирование бокового ствола невозможно, так как выбран режим редактирования скважины',
IDS_EDITING_PROHIBITED_SIDETRACKING_MODE_WELL_SELECTED: 'Редактирование скважины невозможно, так как выбран режим редактирования бокового ствола',
IDS_TARGET_POINT_DEBIT_TOO_SMALL: 'Значение дебита в выбранной точке слишком мало',
IDS_SIDETRACK_NO_DEBIT: 'Значение дебита в выбранной точке слишком мало',
IDS_TREAT_SWEET_SPOT: 'Обработка',
IDS_TREAT_FRACKING: 'ГРП',
IDS_NO_SETTINGS_SET: 'Некорректное значение настройки: ',
IDS_PRESS_APPLY_TO_UPDATE_BRANCH: 'Чтобы обновить траекторию бокового ствола нажмите "Применить"',
IDS_RESET_SUGGESTED_BRANCH: 'Сброс',

IDS_HYDRODYNAMC_MODEL_INFO: 'Информация по гидродинамической модели',
IDS_DB_PROD_INFO: 'Информация по источнику промысловой информации. Эксплутационный объект - ',
IDS_THICKNESS: 'Мощность пласта',
IDS_EFF_THICKNESS: 'Эффективная мощность пласта',
IDS_NET_TO_GROSS: 'Песчанистость',
IDS_CURRENT_SOIL: 'Текущая нефтенасыщенность',

IDS_WATER_CUT_EVALUATION: 'Оценка обводненности',
IDS_BY_OFFSET_WELLS: 'По соседним скважинам',
IDS_BY_CURRENT_OIL_SATURATION: 'По текущей нефтенасыщенности',

IDS_SDM_ERR_NO_TRAJ:'У скважины отсутствует траектория',
IDS_SDM_ERR_NO_PERF:'У скважины отсутствует перфорация',
IDS_SDM_ERR_MULT_ZERO:'Множитель скважина-пласт равен нулю',
IDS_SDM_ERR_NO_TRAJS:'Часть скважин не имеет траекторий',

IDS_SDM_TOO_CLOSE_TO_ANOTHER_SPOT: "Слишком близко к другому sweet spot",
IDS_SDM_NO_HD_MODEL: 'Модель с упрощенной физикой отсутствует в проекте',

IDS_WELLS_WORK_REGIME: 'Режим работы скважин',
IDS_FORMATION_PRESSURE_CALCULATION_RESULTS: 'Результаты расчета',
IDS_FORMATION_PRESSURE_EVALUATION: 'Пластовое давление. Оценка', // на контакт флюидов?
IDS_FORMATION_PRESSURE_CALCULATION: 'Расчет', // на контакт флюидов?
IDS_FORMATION_PRESSURE_HYDRODYNAMIC_CALCULATION: 'Гидро\xADдина\xADми\xADческий расчет', // на контакт флюидов?
IDS_FORMATION_PRESSURE_CORRECTION: 'Поправка', // на контакт флюидов?
IDS_FORMATION_PRESSURE_DEVIATION: 'Откло\xADнение', // 'Стан\xADдарт\xADное откло\xADнение',
IDS_CALCULATE_INTERFERENCE_COEF:'Рассчитать коэффициенты взаимовлияния',
IDS_CUTOFF_ANGLE_45: 'Угол отсечки 45 гр.',
IDS_CUTOFF_ANGLE_90: 'Угол отсечки 90 гр.',
IDS_SEVERAL_CALCULATIONS_RUNNING_CLICK_ICON_TO_SHOW: 'Запущено несколько расчетов гидродинамических моделей. Щелкните на иконку, чтобы посмотреть их список.',
IDS_CANNOT_TRANSIT_WELL_LOW_PRESS_AUTO_HFA: 'Невозможно перевести скважину из-за низкого давления АВТО-ГРП',
IDS_WELLS_INTERFERENCE:'Взаимовлияние скважин',
IDS_3D_SIMULATION: 'Расчет на 3D симуляторе',
IDS_FORMATION_PROPERTIES: 'Свойства пласта',
IDS_SIMPLIFIED_MODEL: 'Упрощенная модель',
IDS_BOUNDARY_CONDITIONS: 'Граничные условия',
IDS_NO_DATABASE_WELLS_FOUND: 'Не найдено скважин в источнике промысловой информации!',
IDS_NO_CANDIDATE_FOR_UNCERTAINTY_CALCULATION: 'Нет ни одного кандидата для расчета неопределенности!',
IDS_NO_DATA_SHORT: 'нет данных',
IDS_CALC_AREA: 'Область расчета',
IDS_SELECTION: 'Выделение',
IDS_VISIBLE_CELLS: 'Видимые ячейки',
IDS_BHP_CLOSE_TO_PRES: 'Забойное давление становится больше пластового. Скважина выключается в течение первого месяца',

IDS_NO_WLPR_NO_WWIR_IN_DATABASE: 'В источнике промысловой информации отсутсвуют данные по дебиту жидкости и по приемистости',
IDS_CALC_TARGET_POINT: 'Расчет целевой точки...',
IDS__SDM_NO_BHP: 'На скважине отсутствует  забойное давление. Она не будет участвовать в расчете',

IDS_CONFIRM_CREATE_TRAJ: 'Все точки траектории за исключением первой будут удалены. Продолжить?',
IDS_FILTERS_APPLY_TO_REGION_1: 'Ячейки вне региона "',
IDS_FILTERS_APPLY_TO_REGION_2: '" не будут проперфорированы',
IDS_ALL_CANDIDATES_ALREADY_CALCULATED: 'Все кандидаты уже рассчитаны',
IDS_TARGET_POINT_WELL_CHARACTERISTICS:'Характеристика прототипа скважины',
IDS_TARGET_POINT_SIDETRACK_CHARACTERISTICS:'Характеристика прототипа бокового ствола',
IDS_GRADIENT_FILL: 'Градиентная заливка',
IDS_AVE_PRESSURE:'Среднее давление',
IDS_CALC_PERM: 'Рассчитать',
IDS_CALC_PERM_METHOD: 'Метод расчета',
IDS_INTERPOLATION_METHOD_RADIAL: 'Радиальный',
IDS_UNCERTAINTY_INPUT_PARAMS: 'Неопределенность входных параметров',

IDS_COMMUNICATION_ERROR: 'Во время обмена данными с сервером произошла ошибка связи',

IDS_CREATE_GRID3D_PARAMS: 'Параметры сетки',
IDS_NX: 'Размерность по X',
IDS_NY: 'Размерность по Y',
IDS_NZ: 'Количество слоев',
IDS_PLASTIC_DEFORMATION_FORM: 'Форма пластообразования',
IDS_PLASTIC_DEFORMATION_FORM_PROPORTIONAL: 'Пропорциональная',
IDS_BUILDING_OF_GRID3D: 'Создается 3D-сетка...',
IDS_GRID3D_SUCCESSFULLY_BUILT: '3D-сетка построена',

IDS_LOG: 'Ln',


// ====================================== Quick Tour =====================================
IDS_WELLS: 'скважины',
IDS_SIDETRACKS: 'боковые стволы',
IDS_WELL_GENITIVE: 'скважины',
IDS_SIDETRACK_GENITIVE: 'бокового ствола',
IDS_WELLS_GENITIVE: 'скважин',
IDS_SIDETRACKS_GENITIVE: 'боковых стволов',
IDS_WELL_ACCUSATIVE: 'скважину',
IDS_SIDETRACK_ACCUSATIVE: 'боковой ствол',
IDS_WELLS_PREPOSITIONAL: 'скважинах',
IDS_SIDETRACKS_PREPOSITIONAL: 'боковых стволах',
IDS_PROJECTED_WELL_GENITIVE: 'проектируемой скважины',
IDS_PROJECTED_SIDETRACK_GENITIVE: 'проектируемого бокового ствола',
IDS_NEW_WELL_GENITIVE: 'новой скважины',
IDS_NEW_SIDETRACK_GENITIVE: 'нового бокового ствола',
IDS_PROJECTED_WELL_PREPOSITIONAL: 'проектируемой скважине',
IDS_PROJECTED_SIDETRACK_PREPOSITIONAL: 'проектируемом боковом стволе',
IDS_LOADED_GENITIVE_FEMALE_SINGLE: 'загруженной',
IDS_LOADED_GENITIVE_MALE_SINGLE: 'загруженного',
IDS_NEW_GENITIVE_FEMALE: 'новой',
IDS_NEW_GENITIVE_MALE: 'нового',
IDS_IT_FEMALE: 'она',
IDS_IT_MALE: 'он',
IDS_WELL_PLANNED_GENITIVE: 'планируемой скважины',
IDS_SIDETRACK_PLANNED_GENITIVE: 'планируемого бокового ствола',
IDS_INCORRECT_PERF_INTERVAL: 'Указано неверное значение интервала перфорации',
IDS_DIAGRAM_ACCUSATIVE: 'диаграмму',
IDS_SECTION_ACCUSATIVE: 'разрез',


IDS_TOUR_SWEET_SPOTS_SUMMARY_TITLE:'Оценка местоположения {0}',
IDS_TOUR_SWEET_SPOTS_SUMMARY_TEXT:
    '<p>На этом этапе проводится поиск наилучших мест для бурения новых {0}. </p>'+
    '<p>Поиск осуществляется следующими методами: </p>' +
    '<ul>'+
    '<li>упрощенная двухфазная гидродинамическая модель; </li>'+
    '<li>гибридная модель; </li>'+
    '<li>статистический анализ промысловых данных. </li>'+
    '</ul>'+
    '<p>Критерием оптимальности выбранного места являются оценки стартового дебита новых {0}.</p>',
IDS_TOUR_SWEET_SPOTS_CALC_SETTINGS_TITLE: 'Настройки расчета',
IDS_TOUR_SWEET_SPOTS_CALC_SETTINGS_TEXT_1W:
    '<p>Необходимо задать: </p>'+
    '<ul>'+
    '<li>тип траектории проектируемой скважины: вертикальная или горизонтальная. </li>',
IDS_TOUR_SWEET_SPOTS_CALC_SETTINGS_TEXT_1ST:
    'Здесь можно задать следующие параметры: ',
IDS_TOUR_SWEET_SPOTS_CALC_SETTINGS_TEXT_2:
    '<li>значение <b>забойного давления</b>, которое будет выставляться на всех проектируемых ' +
    'скважинах. </li>'+
    '<li><b>Условия для перфораций</b> {0}. </li>'+
    '</ul>'+
    '<p>Опциональными являются следующие настройки: </p>'+
    '<ul>'+
    '<li><b>Область поиска</b> местоположения проектируемых {0}. Это позволит ускорить процесс нахождения оптимального решения</li>'+
    '<li><b>Прочие</b> настройки. </li>'+
    '</ul>',
IDS_TOUR_SWEET_SPOTS_SETTINGS_PERF_FILTER_TITLE: 'Настройки перфораций',
IDS_TOUR_SWEET_SPOTS_SETTINGS_PERF_FILTER_TEXT:
    '<p>Для того, чтобы проектируемые скважины были проперфорированы, необходимо включить '+
    'хотя бы один из нижеуказанных фильтров. Интервалы перфораций будут определятся наложением, '+
    'используемых фильтров. </p>',
IDS_TOUR_SWEET_SPOTS_SETTINGS_PERF_FILTER_1_TEXT:
    '<p>Интервалы перфораций будут определятся суперпозицией примененных фильтров. Если '+
    'проект содержит трехмерную фильтрационнуб модель, то фильтр <b>Нефтенасыщенность</b> '+
    'будет включен автоматически со занчениями по умолчанию. </p>',
IDS_TOUR_SWEET_SPOTS_SETTINGS_NOGO_ZONE_TITLE: 'Область поиска',
IDS_TOUR_SWEET_SPOTS_SETTINGS_NOGO_ZONE_TEXT:
    '<p>Данная настройка не является обязательной, но позволяет значительно ускорить поиск '+
    'оптимальных мест для бурения новых скважин. </p>'+
    '<ul>'+
    '<li><b>Плотность мобильных запасов</b>. Ячейки, которые не '+
    'удовлетворяют условию фильтра, закрашиваются серым цветом. </li>'+
    '<li><b>Среднее пластовое давление</b>. Ячейки, которые не '+
    'удовлетворяют условию фильтра, изображаются полупрозрачными. <li>'+
    '<li><b>Минимальное расстояние до существующих скважин</b>. Ячейки, которые не '+
    'удовлетворяют условию фильтра, закрашиваются серым цветом. <li>'+
    '</ul>'+
    '<p>Ниже выводится информация о количестве <b>Извлекаемых запасов</b>, '+
    'рассчитываемых с учетом фильтра <b>Плотность мобильных запасов</b> и '+
    '<b>Запасов в зоне пониженного давления</b>. Последние рассчитываются по "полупрозрачным '+
    'ячейкам, т. е. по той области, в которой условие фильтра <b>Среднее пластовое '+
    'давление</b> не выполняется. <p>',
IDS_TOUR_SWEET_SPOTS_SETTINGS_MORE_TITLE:'Прочие',
IDS_TOUR_SWEET_SPOTS_SETTINGS_MORE_TEXT:
    '<ul>'+
    '<li><b>Максимальное количество вариантов</b> задает предельное количество мест для бурения {0}. </li>'+
    '<li><b>Настройки численного метода</b>. Задают граничные начальные условия при моделировании</li>'+
    '<li><b>Расчет неопределенностей</b>. Эта настройка позволяет производить расчет с учетом '+
    'неопределенностей свойств пласта. Что дает возможность оценить неопределенность дебита '+
    'предполагаемых {1} и сформулировать результат расчета в терминах P10, P50 и P90. </li>'+
    '</ul>',
IDS_TOUR_SWEET_SPOTS_SETTINGS_SIMULATION_SETTINGS_TITLE: 'Настройки численного метода ',
IDS_TOUR_SWEET_SPOTS_SETTINGS_SIMULATION_SETTINGS_TEXT:
    '',
IDS_TOUR_SWEET_SPOTS_RESULTS_TABLE_TITLE:
    'Продуктивность',
IDS_TOUR_SWEET_SPOTS_RESULTS_TABLE_TEXT:
    '<p>В таблице представлены результаты расчета стартовых дебитов новых {0}. </p>'+
    '<ul>'+
    '<li>В колонке <b>Модель с упрощенной физикой</b> показывается значение стартового дебита {1}, '+
    'рассчитанного с помощью упрощенной гидродинамической модели. </li>'+
    '<li>В колонке <b>Аналитические оценки</b> показывается значение стартового '+
    'дебита {2}, полученное на основе аналитического решения уравнения '+
    'притока и промысловых данных. </li>'+
    '<li>В колонке <b>Анализ данных</b> приводится оценка стартового дебита {3}'+
    ' на основе данных о стартовых дебитах соседних скважин. Этот метод основан только на '+
    'данных и не использует знания законов фильтрации. </li>'+
    '</ul>'+
    '<p>Дополнительную информацию о {4} можно получить через контекстное меню, '+
    'открывающееся по правой кнопке мышки или по значку <b>⋮</b>. </p>',
IDS_TOUR_SWEET_SPOTS_SETTINGS_CLASSIFICATION_TEXT:
    'В этом разделе задаются критерии, которые будут использоваться при оценке риска ' +
    'бурения новых скважин.',

IDS_TOUR_START_PAGE_TITLE: 'Начало работы',
IDS_TOUR_START_PAGE_TEXT: 'Для начала работы необходимо в дереве моделей слева выбрать нужную модель',
IDS_TOUR_PROJECT_PAGE_TEXT:
    '<p>В центре экрана вы можете увидеть краткую информацию о выбранной модели. </p>'+
    '<p>Ниже можно посмотреть и/или сгенерировать отчетные документы, а также ознакомиться с сопроводительными '+
    'файлами и документами, находящимися в папке с выбранной гидродинамической моделью. </p>'+
    '<p>В правой панели располагаются кнопки для работы с различными модулями программы: </p>',

IDS_TOUR_3D_MODEL_ANALYSIS_TITLE_1: 'Анализ 3D моделей ',
IDS_TOUR_3D_MODEL_ANALYSIS_TEXT_1: 
    '<p>Приложение предназначено для визуализации и анализа гидродинамических и '+
    'геологических моделей, которые находятся в хранилище.</p>'+
    '<p>В локальной версии программы путь на хранилище можно установить с помощью '+
    'специальной настройки на стартовой странице приложения.</p>'+
    '<p>В online версии путь на хранилище устанавливает администратор.</p>',
IDS_TOUR_3D_MODEL_ANALYSIS_TITLE_2: 'Общая структура приложения', 
IDS_TOUR_3D_MODEL_ANALYSIS_TEXT_2: 
    '<p>Рабочее поле этой страницы состоит из трех панелей </p>'+
    '<ul>'+
    '<li><b>Левая панель</b>. Содержит моделей, имеющихся в хранилище данных.</li>'+
    '<li><b>Центральная панель</b>. Содержит краткую информацию о модели, а также отчетные документы и сопроводительные файлы.</li>'+
    '<li><b>Правая панель</b>. Представляет собой список инструментов для работы с 3D моделями.</li>'+
    '</ul>'+
    'Для начала работы необходимо выбрать проект на левой панели инструмент анализа (например 3D визуализация).',
IDS_TOUR_3D_MODEL_ANALYSIS_TITLE_3: 'Отчетные документы ',    
IDS_TOUR_3D_MODEL_ANALYSIS_TEXT_3:   
    '<p>Отчетные документы вычисляются с помощью плагинов, которые вызываются с '+
    'помощью команды <b>Расcчитать</b>. </p>'+
    '<p>Если есть необходимость в обновлении отчетных документов, то нужно выбрать '+
    'команду <b>Пересчитать</b>. </p>',
IDS_TOUR_3D_MODEL_ANALYSIS_TITLE_4: 'Начало работы ',
IDS_TOUR_3D_MODEL_ANALYSIS_TEXT_4: 
    '<p>Для начала работы необходимо выбрать один из инструментов на правой панели. '+
    'При этом происходит загрузка выбранной модели в оперативную память сервера. </p>',

IDS_TOUR_3D_MODEL_ANALYSIS_MAP_SETTINGS_TITLE: 'Настройка визуализации карт',
IDS_TOUR_3D_MODEL_ANALYSIS_MAP_SETTINGS_TEXT_1: 
    'Нажмите кнопку с изображением шестеренки для получения списка настроек отображения карты',
IDS_TOUR_3D_MODEL_ANALYSIS_MAP_SETTINGS_TEXT_2: 
    'Для изменения цвета круговой диаграммы необходимо кликните левой кнопкой мышки на '+
    'соответствующее обозначение в панели <b>Условные обозначения</b>.',
IDS_TOUR_3D_MODEL_ANALYSIS_PALETTE_SETTINGS_TITLE: 'Настройка цветовой палитры ',
IDS_TOUR_3D_MODEL_ANALYSIS_PALETTE_SETTINGS_TEXT: 
    '<ul>'+
    '<li>Для изменения цветовой палитры необходимо навести курсор мышки на цветовую шкалу '+
    'и сделать двойной щелчок.</li>'+
    '<li>В появившейся справа панели настроек можно отредактировать цветовую палитру.</li> '+ 
    '<li>Для фиксации изменений нужно нажать кнопку <b>Применить.</b></li> '+
    '</ul>',
IDS_TOUR_PROJECT_PAGE_WELL_PLACEMENT_OPTIMIZATION_TITLE: 'Оптимизация положения скважин',
IDS_TOUR_PROJECT_PAGE_WELL_PLACEMENT_OPTIMIZATION_TEXT: 
    '<p>Данный модуль предоставляет средства для решения следующих задач: </p>'+
    '<ul>'+
    '<li>Поиск оптимальных мест для уплотняющего бурения и оценка продуктивности новых '+
    'скважин. Для этого следует нажать кнопку <b>Скважина</b>.</li>'+
    '<li>Поиск скважин для зарезки боковых стволов и оценка продуктивности бокового ствола. '+
    'Этой задаче отвечает кнопка <b>Боковой ствол</b>.</li>'+
    '</ul>',
IDS_TOUR_PROJECT_PAGE_WELL_PLACEMENT_OPTIMIZATION_WELL_TITLE_1: 'Общая структура приложения',
IDS_TOUR_PROJECT_PAGE_WELL_PLACEMENT_OPTIMIZATION_BRANCH_TITLE_1: 'Последовательность действий',
IDS_TOUR_PROJECT_PAGE_WELL_PLACEMENT_OPTIMIZATION_WELL_TEXT_1: 
    '<p>Рабочее поле приложения состоит из трех панелей: </p>'+ 
    '<ul>'+
    '<li>Левая панель. Дерево данных, содержащее список скважин и карт свойств пласта; </li>'+
	'<li>Центральная панель. Область для визуализации карт, разрезов и для создания комбинированных видов; </li>'+
	'<li>Правая панель. Список необходимых команд и настроек для оптимизации расстановки новых скважин. </li>'+
    '</ul>',
IDS_TOUR_PROJECT_PAGE_WELL_PLACEMENT_OPTIMIZATION_WELL_TITLE_2: 'Последовательность действий',
IDS_TOUR_PROJECT_PAGE_WELL_PLACEMENT_OPTIMIZATION_BRANCH_TITLE_2: 'Последовательность действий',
IDS_TOUR_PROJECT_PAGE_WELL_PLACEMENT_OPTIMIZATION_WELL_TEXT_2: 
    '<p>На этой странице представлена последовательность действий для решения задачи оптимизации '+
    'уплотняющего бурения. </p>'+
    '<ul>'+
    '<li><b>Оценка местоположения скважины</b>. Поиск оптимальных мест для бурения проектируемых '+
    'скважин на основании оценки стартового дебита.</li>'+
    '<li><b>Редактор траектории</b>. Просмотр и редактирование траекторию проектируемой скважины.</li>'+
    '<li><b>Редактор перфораций</b>. Просмотр и редактирование перфорации проектируемой скважины.</li>'+
    '<li><b>Прогноз добычи</b>. Расчет среднесрочного профиля добычи проектируемой скважины '+
    'с помощью упрощенного гидродинамического моделирования.</li>'+
    '</ul>'+
    '<p>Обязательным действием явлется оценка местоположения скважины. </p>',

IDS_TOUR_PROJECT_PAGE_MODEL_ANALYSIS:
    '<ul>'+
    '<li>3D визуализация</li>'+
    '<li>Технологические показатели</li>'+
    '<li>Разрез</li>'+
    '<li>Рассчитать</li>'+
    '</ul>',
IDS_TOUR_PROJECT_PAGE_EDIT_MODELS:
    '<ul>'+
    '<li>Скважина</li>'+
    '<li>Боковой ствол</li>'+
    '</ul>',
IDS_TOUR_PROJECT_PAGE_OPTIMIZE_MODELS: 
    '<ul>'+
    '<li>Области пониженного давления</li>'+
    '<li>Фильтр по промысловым данным</li>'+
    '<li>Фильтр по модельным данным</li>'+
    '<li>Перевод скважин</li>'+
    '<li>Оптимизация ППД</li>'+
    '</ul>',
IDS_TOUR_PROJECT_PAGE_RUN_MACRO: 'Редактирование и запуск макросов',
IDS_TOUR_WELLS_STAT_TEMPLATES_TITLE: 'Выбор типа выводимых данных',
IDS_TOUR_WELLS_STAT_TEMPLATES_TEXT: 'Выберите тип данных для вывода информации на кроссплот',
IDS_TOUR_WELLS_SLIDER_DEBIT_TITLE: 'Настройка порогового значения дебита',
IDS_TOUR_WELLS_SLIDER_DEBITS_TEXT: 
    'Настройте пороговое значение дебита для опредения скважин к группам низкодебитных и высокодебитных',
IDS_TOUR_WELLS_SKIRT_INTERVAL_TITLE: 'Настройка интервала отклонения',
IDS_TOUR_WELLS_SKIRT_INTERVAL_TEXT: 
    'Выберите величину допустимого интервала отклонения расчетного значения от фактического '+
    'значения для групп низкодебитных и высокодебитных скважин',
IDS_TOUR_WELLS_TABLE_TITLE: 'Таблица со статистикой по скважинам',
IDS_TOUR_WELLS_TABLE_TEXT: 
    '"Всего" - общее количество скважин в группе, "В интервале" - количество скважин внутри '+
    'интервала отклонения, "Вне интервала - количество скважин за пределами интервала отклонения"',
//IDS_TOUR_WELLSEARCH_FILTERS_TEXT: 'Фильтры позволяют выбрать из списка всех добывающих скважин те, которые наилучшим образом подходят для врезки бокового ствола. После того, как нужная скважина выбрана, дается команда начать боковой ствол.',
IDS_TOUR_WELLSEARCH_FILTERS_TEXT:
    '<p>В разделе <b>Фильтр по скважинам</b> можно задать один или несколько критериев для таких скважин:</p>'+
    '<ul>'+
    '<li>дебит нефти;</li>'+
    '<li>обводненность</li>'+
    '<li>диаметр колонны</li>'+
    '<li>расстояние до T1</li>'+
    '</ul>'+
    '<p>Нажмите кнопку <b>Рассчитать</b>. Запустится процесс оценки возможности зарезки '+
    'бокового ствола с пробуриванием его в выбранную целевую точку. </p>',
IDS_TOUR_WELLSEARCH_TABLE:
    '<p>В таблице <b>Добывающие скважины</b> отобразится список всех возможных скважин для зарезки '+
    'бокового ствола. Скважины, для которых выбранные в разделе фильтров условия будут '+
    'удовлетворены, будут отмечены в таблице зеленым кружком, остальные красным. </p>',

IDS_TOUR_3D_VISUALIZATION_SUMMARY_TITLE: 'Общая структура модуля', 
IDS_TOUR_3D_VISUALIZATION_SUMMARY_TEXT: 
    '<p>В левой панели представлены все объекты, имеющиеся в модели: </p>'+ 
    '<ul>'+
	'<li><b>Статические</b> и <b>Динамические</b> 3D параметры.</li>'+ 
	'<li><b>Карты</b>. Рассчитываются путем осреднения трехмерных параметров. </li>'+
	'<li><b>Скважины</b>.</li>'+
	'<li><b>Регионы</b>. Регион представляет собой набор произвольного количества ячеек модели. Например '+
    'это могут быть ячейки, входящие в нефтенасыщенную зону или регионы инициализации. </li>'+
    '</ul>',
IDS_TOUR_3D_VISUALIZATION_CUBES_TITLE: 'Выбор параметра для визуализации',
IDS_TOUR_3D_VISUALIZATION_CUBES_TEXT: 
    'В дереве данных откройте раздел <b>Статические параметры</b> или <b>Динамические параметры</b> и выберите '+
    'интересующее свойство. Его визуализация происходит автоматически. Также, в качестве '+
    'отображаемого можно выбрать и <b>Структуру</b>.',
IDS_TOUR_3D_VISUALIZATION_CELL_FILTER_TITLE: 'Фильтр по ячейкам',
IDS_TOUR_3D_VISUALIZATION_CELL_FILTER_TEXT: 
    '<ul>'+
    '<p><li>Раскройте один из разделов: <b>Геометрия сетки</b>, <b>Статические параметры</b> или <b>Динамические параметры</b> '+
    'и отметьте тот, по которому требуется установить фильтр. Можно выбрать несколько параметров. При этом в загаловке '+
    'раздела отобразится количество выбранных параметрв.</li></p>'+
    '<p><li>Задайте требуемый диапазон значений параметра, передвигая ползунки слайдера либо вводя значения '+
    'в соответствующие поля ввода.</li></p>'+
    '<p><li>Для подтверждения нажмите <b>Применить фильтр</b>. Для сброса фильтров нажмите '+
    '<b>Сбросить фильтр</b>. </li></p>'+
    '<ul>',
IDS_TOUR_3D_VISUALIZATION_CREATE_REGION_TITLE: 'Создание региона по видимым ячейкам',
IDS_TOUR_3D_VISUALIZATION_CREATE_REGION_TEXT: 
    'Для создания региона по видимым ячейкам нажмите <b>Создать регион '+
    'по видимым ячейкам</b> после настройки параметров либо после '+
    'применения фильтра. В правом нижнем углу правой панели появится '+
    'уведомление о создании региона.',
IDS_TOUR_3D_VISUALIZATION_REGIONS_TITLE: 'Список регионов',
IDS_TOUR_3D_VISUALIZATION_REGIONS_TEXT: 
    '<p>Созданный регион появится в списке регионов. Переименовать '+
    'или удалить регион можно через контекстное меню, открывающееся по правой '+
    'кнопке мышки или по значку <b>⋮</b>. </p>'+
    '<p>Создать регион также возможно, нажав кнопку <b>+</b>. </p>',

IDS_TOUR_3D_SECTION_SUMMARY_TITLE: 'Разрез',
IDS_TOUR_3D_SECTION_SUMMARY_TEXT: 
    '<p>'+
    'Модуль предназначен для построения и визуализации разрезов по скважинам, '+
    'а также для редактирования свойств ячеек, пересекаемых скважинами (blocked wells).'+
    '</p>'+
    '<p>'+
    'Модуль позволяет визуализировать: '+
    '</p>'+    
    '<ul>'+    
    '<li>Разрезы, расcчитанные по геолого-гидродинамической модели.</li>'+
    '<li>Трехмерное представление профиля разреза.</li>'+
    '<li>Планшет по скважинам и результаты интерпретации ГИС (РИГИС).</li>'+
    '</ul>',
IDS_TOUR_3D_SECTION_DESKTOP_TITLE: 'Рабочее поле',
IDS_TOUR_3D_SECTION_DESKTOP_TEXT: 
    '<p>'+
    'Рабочее поле модуля состоит из трех частей: '+
    '</p>'+
    '<ul>'+    
    '<li><b>Левая часть</b> содержит дерево данных, в котором выбираются объекты для отображения '+
         'на разрезе. Такими объектами являются скважины и поверхности. </li>'+
    '<li><b>Центральная часть</b> содержит визуализацию разреза.</li>'+
    '<li><b>Правая часть</b> содержит панель инструментов и информацию о выбранном объекте.</li>'+
    '</ul>'+
    '<p>'+
    'Выбранные настройки действуют только в рамках данного модуля и не влияют на работу '+
    'других модулей приложения.'+    
    '</p>',
IDS_TOUR_3D_SECTION_ADD_WELL_TITLE: 'Добавление скважин на разрез',    
IDS_TOUR_3D_SECTION_ADD_WELL_TEXT:
    '<ul>'+
    '<li>В дереве данных откройте раздел <b>Скважины</b>.</li>'+
    '<li>Выберите одну из скважин и нажмите мышкой на значек <b>⋮</b> справа от ее имени.</li>'+
    '<li>Выполните команду <b>Добавить на {0}</b>.</li>'+
    '</ul>'+
    '<p>'+
    'Разрез отображается в центральной панели модуля. По умолчанию, '+
    'выбранные скважины визуализируется на разрезе по геолого-гидродинамической модели. '+
    '</p>',
IDS_TOUR_3D_SECTION_VIEW_TYPE_TITLE: 'Способы отображения разреза',
IDS_TOUR_3D_SECTION_VIEW_TYPE_TEXT:
    '<p>'+
    'Переключение между различными видами визуализации осуществляется с помощью команд '+
    'на панели инструментов.'+
    '</p>',
IDS_TOUR_3D_SECTION_EDIT_TITLE: 'Редактирование свойств ячеек',
IDS_TOUR_3D_SECTION_EDIT_TEXT:     
    '<p>'+
    'Для изменения свойств ячеек используйте инструмент <b>Калькулятор</b>. Перед началом '+
    'работы убедитесь, что инструмент включен в настройках модуля.'+
    '</p>'+
    '<p>'+
    'В командной строке калькулятора введите арифметическое выражение и выполните команду. '+
    'Указанное выражение будет применено ко всем выделенным ячейкам. Если ячейки не выделены, '+
    'операция будет выполнена для всей модели.'+
    '</p>',
IDS_TOUR_3D_SECTION_SELECT_TITLE: 'Выделение ячеек',
IDS_TOUR_3D_SECTION_SELECT_TEXT: 
    '<p>'+
    'Выделение ячеек может выполняться с помощью инструмента <b>Диаграмма скважины</b>, который '+
    'необходимо предварительно включить в настройках модуля.'+
    '</p>'+
    '<p>'+
    'Чтобы выделить ячейки, нажмите и удерживайте левую кнопку мыши, затем выделите на '+
    'диаграмме скважины требуемый диапазон глубин. Соответствующие ячейки на разрезе '+
    'модели будут выделены автоматически.'+
    '</p>'+
    '<p>'+
    'После выделения к выбранным ячейкам можно применить операции калькулятора.'+
    '</p>',
    
IDS_TOUR_WELL_CONVERSION: 'Перевод скважин',
IDS_TOUR_WELL_CONVERSION_SUMMARY:
    '<p>Перевод скважин в нагнетание является одним из методов для оптимизации '+
    'системы заводнения и поддержания пластового давления. Данный модуль позволяет '+
    'найти добывающие и остановленные скважины, перевод которых в нагнетание даст '+
    'наибольший прирост в добыче. Для этого необходимо выполнить следующие действия: </p>'+
    '<h3>Выбрать скважины кандидаты для перевода в нагнетание</h3>'+
    '<p>Скважины кандидаты выбираются из списков добывающих и остановленных скважин. '+
    'Выбор добывающих скважин может быть сделан вручную или с помощью специальных '+
    'фильтров. Остановленные скважины выбираются из соответствующего списка вручную. </p>'+
    '<ul>'+
    '<li>Фильтр по дебиту скважин</li>'+
    '<li>Фильтр по обводненности</li>'+
    '</ul>'+
    '<h3>Задать настройки расчета</h3>'+
    '<p>Для проведения расчетов необходимо задать следующие настройки.</p>'+
    '<ul>'+
    '<li><b>Задать минимальное и максимальное значение приемистости.</b> Эта насройка '+
    'задает пределы, в которых может изменятся приемистость скважины после ее '+
    'перевода в нагнетание.</li>'+
    '<li><b>Количество вариантов.</b> Определяет количество значений, на которые '+
    'разбивается выбранный интервал приемистости. Если количество вариантов равно '+
    'двум, то приемистость переведенной скважины будет принимать значения равные '+
    'верхней и нижней границы интервала </li>'+
    '<li><b>Давление авто ГРП.</b> Этот параметр определяет максимальное забойное '+
    'давление, которое может быть на скважине при ее работе после перевода в '+
    'нагнетание. Если забойное давление будет превышать давление авто ГРП, то '+
    'контроль скважин будет осуществляться по забойному давлению равному давлению '+
    'авто ГРП.</li>'+
    '</ul>'+
    '<h3>Проведение расчетов</h3>'+
    '<p> Для проведения расчетов нужно нажать кнопку <b>Рассчитать</b> в разделе '+
    'Действия. Скважины кандидаты поочередно переводятся в нагнетание, после чего '+
    'проводится прогнозный расчет на модели с упрощенной физикой. Эффект от перевода '+
    'оценивается по изменению суммарной добычи нефти по сравнению с базовым расчетом. '+
    'Под базовым расчетом понимается расчет без перевода каких-либо скважин в '+
    'нагнетание. После завершения каждого расчета, тестируемая скважина переводится '+
    'в исходное состояние </p>'+
    '<h3>Просмотр результатов </h3>'+
    '<p>По окончании расчета автоматически откроется страница с результатами перевода '+
    'в нагнетание скважин кандидатов. &gt;Результаты расчета представлены в таблице '+
    'КАНДИДАТЫ ДЛЯ ПЕРЕВОДА.<br>'+
    'В крайне правом столбце таблицы приводится изменение добычи нефти после перевода '+
    'соответствующей скважины. Чтобы сделать перевод скважины , нужно выделить '+
    'кандидата в таблице и нажать кнопку</p>',

IDS_TOUR_SIDETRACK_HEADER: 'Построение бокового ствола',
IDS_TOUR_SIDETRACK_SUMMARY:
    '<p>Зарезка боковых стволов (ЗБС) является одним из наиболее эффективных способов '+
    'увеличения добычи нефти, а определение оптимального их расположения является '+
    'распространенной задачей при разработке месторождений. Данный модуль предоставляет '+
    'функциональные возможности для поиска целевых точек для бурения боковых стволов и '+
    'выбора скважин-кандидатов для их зарезки. Процесс поиска скважин для ЗБС и '+
    'оптимизации траектории ЗБС состоит из следующих этапов.</p>'+
    '<ul>'+
    '<li><b>Поиск целевых</b>, т. е. потенциально выгодных точек для забуривания бокового '+
    'ствола. Критерием для их поиска служит наилучшая потенциальная продуктивность. '+
    'Поиск базируется на моделировании с упрощенной физикой.</li>'+
    '<li><b>Выбор скважин-кандидатов для ЗБС</b>. Каждая из добывающих скважин '+
    'оценивается на предмет возможности зарезки бокового ствола и прокладывания '+
    'его до целевой точки. По выбору пользователя применяются фильтры на продуктивность, '+
    'обводненность, диаметр скважины, а также расстояние от нее до целевой точки.</li>'+
    '<li><b>Построение бокового ствола</b>. Решается задача построения оптимальной '+
    'кривой, соединяющей точку врезки и целевую точку.</li>'+
    '<li><b>Оценка рисков</b>. Варьируя азимутом и углом отклонения по вертикали, '+
    'программа строит серию (веер) кривых. Затем для каждой из них производится '+
    'расчет дебита. По результатам расчета строится диаграмма.</li>'+
    '</ul>',
IDS_TOUR_WFO_SUMMARY: 
    'Подбор оптимальных режимов работы нагнетательных скважин позволяет поддерживать '+
    'пластовое давление и рационально вырабатывать запасы. Настоящий модуль позволяет '+
    'определить значение приемистостей (или забойных давлений) нагнетательных скважин, '+
    'которые позволяют получить максимальный прирост добычи нефти. Оптимизация происходит '+
    'на основе многовариантных расчетов на модели с упрощенной физикой.',
IDS_TOUR_WFO_TABLE:
    '<p>Для нахождения оптимальных режимов работы необходимо выполнить следующие действия:</p>'+
    '<ul>'+
    '<li>Выбрать в таблице нагнетательные скважины, режимы которых будут варьироваться в процессе '+
    'оптимизации, установив флаг в крайней левой колонке. Также в таблице приведены значения базовой '+
    'приемистости (или забойного давления), взятые из модели на дату мероприятия, и границ интервала, '+
    'в пределах которого они будет варьироваться. Невыбранные скважины также будут учитываться в '+
    'расчетах, но их режимы не будет варьироваться и останутся равными базовым значениям. </li>'+
    '</ul>',
IDS_TOUR_WFO_SETTINGS:
    '<p>Настройки расчета</p>'+
    '<ul>'+
    '<li>Оптимизируемые параметры. Работа нагнетательных скважин может задаваться с помощью '+
    'задания их приемистостей или забойного давления.</li>'+
    '<li>Фиксированная закачка. Нужно активизировать эту настройку если необходимо держать '+
    'общий темп закачки всех нагнетательных скважин.</li>'+
    '<li>В результате расчетов оптимизируется целевая функция H, которая имеет размерность '+
    'тыс. рублей. Для ее задания необходимо ввести весовые коэффициенты, которые означают '+
    'стоимость добычи тонны нефти и воды (коэффициенты A, B), а также стоимость закачки '+
    'тонны воды (коэффициент С).</li>'+
    '</ul>',
IDS_TOUR_WFO_RESULTS:
    '<p>Просмотр результатов</p>'+
    '<ul>'+
    'После окончания расчетов автоматически откроется страница с результатами вычислений. '+
    'Результаты представляются 4-мя различными представлениями.',
IDS_TOUR_CANDIDATE_WELLS_HEADER: 'Подбор скважин',
IDS_TOUR_CANDIDATE_WELLS_SUMMARY: 
    'На этом этапе производится подбор скважин, из которых можно провести боковой ствол в '+
    'выбранную точку T1. Для этого из каждой добывающей скважины проводятся боковые стволы '+
    'в выбранную точку T1. Все боковые стволы должны удовлетворять условиям на максимальную '+
    'кривизну (685 м) и предельный угол отхода от материнского ствола (30 градусов). Если '+
    'из скважины удается провести траекторию в точку T1, то ее индикатор будет иметь зеленый '+
    'цвет. В противном случае скважина будет иметь красный идентификатор.',
IDS_TOUR_CANDIDATE_WELLS_FILTER_TITLE: 'Фильтр',
IDS_TOUR_CANDIDATE_WELLS_FILTER_TEXT: 
    'Список скважин кандидатов может быть ограничен с помощью специальных фильтров, использующих '+
    'промысловую информацию о добывающих скважинах. Работа фильтров по дебиту нефти, обводненности '+
    'и диаметру колонны требует подключения к источнику данных с промысловой информацией.',
IDS_TOUR_CANDIDATE_WELLS_TABLE_TITLE: 'Таблица добывающих скважин',
IDS_TOUR_CANDIDATE_WELLS_TABLE_TEXT: 
    'Если из добывающей скважины существует возможность провести боковой ствол, удовлетворяющий '+
    'выбранным фильтрам и технологическим ограничениям, то такие скважины будут маркироваться '+
    'в таблице <b>Добывающие скважины</b> зеленым кружком. Скважины, из которых нельзя провести боковой '+
    'ствол, маркируются красным кружком. Если подвести указатель курсор мышки на красный кружок, '+
    'то появится всплывающая подсказка, объясняющая причину невозможности проведения бокового ствола.',
IDS_TOUR_TRAJ_EDIT_SIDETRACK_BY_SWEET_SPOT_HEADER: 'Редактор траекторий',
IDS_TOUR_TRAJ_EDIT_SIDETRACK_BY_SWEET_SPOT_SUMMARY:
    'После окончания расчета различных траекторий автоматически выбирается геометрия бокового '+
    'ствола, которая обеспечивает максимальный стартовый дебит. Характеристики выбранной траектории '+
    '(длина ствола в пласте, его дебит и кривизна) представлены в разделе <b>Параметры траектории</b>.'+
    '<p>Если по каким либо причинам выбор траектории бокового ствола не является оптимальным, '+
    'его можно изменить. Это можно сделать двумя способами</p>',
IDS_TOUR_TRAJ_EDIT_SIDETRACK_BY_SWEET_SPOT_1:
    '<b>Ручное изменение текущей траектории.</b> Выбранная траектория может быть изменена с '+
    'помощью мышки. Для этого не+обходимо навести указатель мышки на специальные точки маркирующие '+
    'траекторию скважины и переместить точку, удерживая левую кнопку мышки.',
IDS_TOUR_TRAJ_EDIT_SIDETRACK_BY_SWEET_SPOT_2:
    '<b>Выбрать другую рассчитанную траекторию.</b> В разделе РАСПРЕДЕЛЕНИЕ ПРОДУКТИВНОСТИ '+
    'представлена гистограмма показывающая распределение дебита для возможных траекторий боковых '+
    'стволов. Если необходимо выбрать другую траекторию, нужно навести указатель мышки на левый '+
    'верхний угол нужного столбца гистограммы. При этом появится индикатор (точка), по которому '+
    'нужно щелкнуть левой кнопкой мышки. В результате в поле графика отобразится зависимость '+
    'дебита бокового ствола от его азимута. Каждая точка этой зависимости соответствует '+
    'определенной траектории. Если выбрать какую-либо точку с помощью левой кнопки мышки, '+
    'то соответствующая траектория отобразится на карте и на разрезе. Нажмите кнопку '+
    'ПРИМЕНИТЬ, чтобы зафиксировать выбранную траекторию.',

IDS_TOUR_LOW_PRESSURE_ZONE_HEADER: 'Поиск зон пониженного давления',
IDS_TOUR_LOW_PRESSURE_ZONE_SUMMARY:
    '<p>В этом модуле выбираются добывающие скважины, которые находятся в зоне пониженного давления '+
    'с невыработанными остаточными запасами. </p>'+
    '<p>Повышение пластового давления на таких скважинах может приводить к увеличению добычи нефти. </p>'+
    '<p>В дальнейшем эти скважины будут использоваться при оптимизации режимов работы нагнетательных '+
    'скважин, а также при оптимизации переводов скважин в нагнетание. </p>',
IDS_TOUR_LOW_PRESSURE_ZONE_FILTER_TITLE: 'Область поиска',
IDS_TOUR_LOW_PRESSURE_ZONE_FILTER_TEXT:
    '<p><b>Плотность мобильных запасов</b>. Ячейки, которые не ' +
    'удовлетворяют условию фильтра, закрашиваются серым цветом. </p>' +
    '<p><b>Среднее пластовое давление</b>. Ячейки, которые не ' +
    'удовлетворяют условию фильтра, изображаются полупрозрачными. </p>' +
    '<p>Ниже выводится информация о количестве <b>Подвижных запасов</b>, '+
    '<b>Площади</b> и усредненном <b>Пластовом давлении</b>. </p>'+
    '<p>Эти величины рассчитываюстя в области, в которой выполнены условия, задданные фильтрами. </p>',
IDS_TOUR_LOW_PRESSURE_ZONE_TABLE_TITLE: 'Добывающие скважины',
IDS_TOUR_LOW_PRESSURE_ZONE_TABLE_TEXT:
    '<p>В результате применения фильтров в таблице автоматически выделятся скважины, '+
    'находящиеся в выбранной зоне. Список выбранных скважин может быть изменен вручную. </p>'+
    '<p>Необходимо помнить, что повторное применение фильтров приведет к потере результатов ручного редактирования. </p>',

IDS_TOUR_PERF_EDIT_SUMMARY_TITLE: 'Редактор перфораций',
IDS_TOUR_PERF_EDIT_SUMMARY_TEXT:
    '<p>Перфорации проектируемых скважин можно задавать как с помощью специальных фильтров, так и вручную, с помощью мышки. </p>'+
    '<ul>'+
    '<li>Фильтр <b>по нефтенасыщенности</b> дает возможность проперфорировать ствол '+
    'скважины в пределах тех ячеек, в которых нефтенасышенность лежит в пределах '+
    'выбранного диапазона значений. Этот фильтр работает только при наличии трехмерной сетки.</li>'+
    '<li>Фильтр <b>по расстоянию до ВНК</b>. Если имеется трехмерная сетка, то этот '+
    'фильтр перфорирует ячейки, через которые проходит скважина, расстояние от центра '+
    'которых до ВНК будет не меньше выставленного значения.</li>'+
    '<li>Фильтр <b>по абсолютной глубине</b> позволяет проперфорировать скважину в '+
    'заданном диапазоне глубин.</li>'+
    '</ul>',
IDS_TOUR_PROJECT_MANAGER_TITLE: 'Менеджер проектов',
IDS_TOUR_PROJECT_MANAGER_SUMMARY_1:
    '<p>В этом модуле создается проект, который в дальнейшем будет использоваться во '+
    'всех прикладных модуляx программы. </p>'+
    '<p>Проект содержит ссылки на источники данных: гидродинамическая модель, '+
    'геологическая модель и источник промысловых данных. </p>'+
    '<p>Для работы программы достаточно существования хотя бы одной из этих ссылок. '+
    'Отсутствие указателей на какой-либо источник данных может приводить к невозможности '+
    'использования всего доступного функционала программы.</p>',
IDS_TOUR_PROJECT_MANAGER_SUMMARY_2: 
    '<p>В разделе <b>гидродинамическая модель</b> устанавливается путь на входной файл '+
    '(data file) уже рассчитанной гидродинамической модели. Модель может быть в '+
    'форматах ECLIPSE, TEMPEST, NEXUS, ТехСхема.</p>'+
    '<p>В разделе <b>геологическая модель</b> устанавливается путь на папку, в которой '+
    'находится геологическая модель. Модель может иметь формат RMS.</p>'+
    '<p>В разделе <b>промысловая информация</b> необходимо выбрать источник с промысловой '+
    'информацией. По умолчанию используется RDS</p>'+
    '<p>Предполагается, что все эти источники информации относятся к одному месторождению.</p>',
IDS_TOUR_PROJECT_MANAGER_MAPS_TITLE: 'Свойства пласта',
IDS_TOUR_PROJECT_MANAGER_MAPS_TEXT: 
    '<p>Для работы некоторых прикладных модулей программы требуются данные о '+
    'пространственном распределении свойств пласта таких как:</p>'+
    '<ul>'+
    '<li>Проницаемость</li>'+
    '<li>Пластовое давление</li>'+
    '</ul>'+
    '<p>Эти параметры будут использоваться при оценке продуктивности новых скважин. '+
    'Свойства пласта задаются в виде карт или константных значений. Если в имеющихся '+
    'источниках данных не находится карта текущего пластового давления, то ее можно '+
    'рассчитать по информации, имеющейся в источнике промысловой информации.</p>',
IDS_TOUR_PROJECT_MANAGER_PRESSURE_MAP_SUMMARY_TITLE: 'Расчет пластового давления',
IDS_TOUR_PROJECT_MANAGER_PRESSURE_MAP_SUMMARY_TEXT: 
    '<p>Для построения карты пластовых давлений на выбранную дату используется информация '+
    'о текущих дебитах скважин и имеющихся замерах пластового давления. Построение '+
    'ведется на основании гибридного подхода. </p>'+
    '<p>Для построения карты пластовых давлений нужно: </p>'+
    '<ul>'+
    '<li>Выбрать <b>Дату</b>, на которую будет строиться карта пластового давления. '+
    'При этом из базы данных будут загружаться режимы работы скважин на выбранную дату. </li>'+
    '<li>В разделе <b>Прочее</b> необходимо задать значения пластового давления на '+
    'границах моделируемой области. Чаше всего его роль играет начальное пластовое давление. </li>'+
    '<li>Нажать кнопку <b>Рассчитать</b>.</li>'+    
    '</ul>',
IDS_TOUR_PROJECT_MANAGER_PRESSURE_MAP_TABLE_TITLE: 'Расчет пластового давления',
IDS_TOUR_PROJECT_MANAGER_PRESSURE_MAP_TABLE_TEXT:
    '<p>Таблица Режим работы скважин содержит информацию о режимах работы скважин '+
    'на выбранную дату. </p>'+ 
    '<ul>'+
    '<li>Голубым цветом помечаются имена и приемистости нагнетательных скважин. </li>'+
    '<li>Поскольку оценок пластовых давлений сравнительно немного, то подгружаются те оценки, '+
    'которые проводились менее чем за три месяца до выбранной даты. </li>'+
    '</ul>',
IDS_TOUR_PROJECT_MANAGER_PRESSURE_MAP_PERM_TITLE: 'Расчет пластового давления',
IDS_TOUR_PROJECT_MANAGER_PRESSURE_MAP_PERM_TEXT:
    'При расчете пластового давления используются данные о проницаемости '+
    'пласта, которые задавались на предыдущем шаге, в окне <b>Менеджер проектов. '+
    'Редактировать проект.</b> ',

IDS_TOUR_MODEL_DATA_FILTER_HEADER: 'Фильтр по модельным данным',
IDS_TOUR_MODEL_DATA_FILTER_SUMMARY: 
    'В этом модуле рассчитываются коэффициенты влияния нагнетательных скважин на добычу '+
    'нефти (третья колонка в таблице <b>Нагнетательные скважны</b>) и создается карта '+
    'трассеров по выбранным нагнетательным скважинам. ' +
    'Чтобы рассчитать карту трассеров и коэффициенты влияния, необходимо выполнить '+
    'следующие действия (нажмите <b>Далее</b>).',
IDS_TOUR_MODEL_DATA_FILTER_TABLE_TITLE: 'Таблица нагнетательных скважин',
IDS_TOUR_MODEL_DATA_FILTER_TABLE_TEXT: 
    '<p>Отметьте представляющие интерес скважины в крайней '+
    'левой колонке таблицы <b>Нагнетательные скважны</b>. В ней приведены значения '+
    'базовой приемистости, взятые из модели на дату мероприятия. </p>'+
    '<p>За основу для коэффициентов влияния берется информация о том, когда нагнетательная '+
    'скважина работает с базовой приемистостью и когда — с дополнительной. </p>'+
    '<p>Также в крайней правой колонке по контекстному меню можно получить дополнительную '+
    'информацию. </p>',
IDS_TOUR_MODEL_DATA_FILTER_CALC_SETTINGS_TITLE: 'Настройки расчета:',
IDS_TOUR_MODEL_DATA_FILTER_CALC_SETTINGS_TEXT:
    '<ul>'+
    '<li>Время расчета </li>'+
    '<li>Тип залежи </li>'+
    '</ul>',
IDS_TOUR_MODEL_DATA_FILTER_CALC_ACTIONS_TITLE: 'Результаты расчета',
IDS_TOUR_MODEL_DATA_FILTER_CALC_ACTIONS_TEXT: 
    '<p>Для запуска на расчет нажмите кнопку <b>Рассчитать</b>. </p>'+
    '<p>После окончания расчетов автоматически откроется раcсчитанная динамическая '+
    'карта трассеров. Также ее можно будет открыть нажатием кнопки <b>Результаты</b>. </p>',
IDS_TOUR_MODEL_DATA_FILTER_CALC_RESULT_TIME_TITLE: 'Временной шаг',
IDS_TOUR_MODEL_DATA_FILTER_CALC_RESULT_TIME_TEXT: 
    'Двигаясь по временным шагам, можно наблюдать, как распространяется вода от нагнетательных '+
    'скважин',
IDS_TOUR_MODEL_DATA_FILTER_CALC_RESULT_TABLE_TITLE: 'Таблица нагнетательных скважин',
IDS_TOUR_MODEL_DATA_FILTER_CALC_RESULT_TABLE_TEXT: 
    'В таблице <b>РЕЗУЛЬТАТЫ РАСЧЕТОВ</b>, в третьей колонке, отображаются коэффициенты '+
    'влияния. В крайней правой колонке по контекстному меню доступна подробная информация '+
    'по расчету',

IDS_TOUR_SELECT_WELL_IN_TREE:
    '<p>В дереве можно выбрать {0} для дальнейшей работы. </p>'+
    '<p>При этом необходимо иметь в виду, что редактирование {1}, {2}, из '+
    'модели, запрещено. </p>',
IDS_TOUR_TRAJ_EDIT_SUMMARY_TITLE_1:'Назначение модуля',
IDS_TOUR_TRAJ_EDIT_SUMMARY_TEXT_1:
    '<p>Это модуль позволяет визуализировать траектории как новых, так и уже существующих '+
    'скважин. При этом траектории новых скважин доступны для редактирования. <p>'+
    '<p>Траектория выбранной в дереве скважины выделяется на карте и на разрезе, '+
    'а также отображается в табличном виде в панели справа. </p>',
IDS_TOUR_EDIT_NEW_WELL_TITLE:'Создание новой скважины',
IDS_TOUR_EDIT_NEW_WELL_TEXT:
    '<ul>'+
	'<p><li>Для создания {0} {1} нажмите кнопку <b>+</b>, находящуюся в правом нижнем '+
    'углу центральной панели. После этого новая скважина появится в дереве данных, '+
    'а программа автоматически перейдет в режим создания траектории. </li></p>'+
	'<p><li>Траектория скважины задается точками. Двойной щелчок мышки на карте добавляет новую точку в конец траектории. </li></p>'+
    '</ul>',
IDS_TOUR_TRAJ_EDIT_SUMMARY_TITLE_2: 'Редактирование траектории',
IDS_TOUR_TRAJ_EDIT_SUMMARY_TEXT_2:
    '<p>Доступно два способа редактирования траектории: </p>'+
    '<ul>'+
	'<li>Интерактивно, c помощью мышки, на карте либо на разрезе. </li>'+
    '<li>Внося изменения в таблицу <b>Траектория</b>. </li>'+
    '</ul>',
IDS_TOUR_TRAJ_MASTER_TITLE:'Создание по шаблону',
IDS_TOUR_TRAJ_MASTER_TEXT:
    'Задайте <b>длину</b> ствола, его <b>азимут</b> и <b>отклонение от '+
    'вертикали</b> и нажмите кнопку <b>Создать</b>. В результате скважина получит '+
    'траекторию, состоящую из двух точек и соответствующую заданным параметрам. ',
IDS_TOUR_TRAJ_INTERACTIVE_TITLE: 'Интерактивное редактирование траектории',
IDS_TOUR_TRAJ_INTERACTIVE_TEXT:
    '<ul>'+
    '<li>Чтобы добавить точку в конец траектории, используйте двойной щелчок. </li>'+
    '<li>Можно также передвигать определенные точки траектории в горизонтальном '+
    '– на карте либо в вертикальном – на разрезе направлениях. Для этого следует '+
    'навести курсор мышки на траекторию в нужном месте и, удерживая нажатой левую '+
    'кнопку, переместить точку.</li>' +
    '<li>Удалить точку можно с помощью контекстного меню, предварительно наведя на нее '+
    'курсор мышки.</li>'+
    '</ul>'+
    '<p>Изменения, произведенные таким образом, автоматически отобразятся в таблице. </p>',
IDS_TOUR_TRAJ_TABLE_TITLE: 'Траектория',
IDS_TOUR_TRAJ_TABLE_TEXT:
    '<p>Выделите щелчком мышки нужную ячейку: «X», «T» или «TVD» и отредактируйте '+
    'ее содержимое. По правой кнопке мышки, а также по значку <b>⋮</b> доступны команды: </p>'+
    '<ul>'+
    '<li><b>Добавить</b>. Добавляет пустую строку в конец таблицы для последующего ее '+
    'заполнения. Незаполненная строка будет проигнорирована.</li>'+
    '<li><b>Вставить</b>. Добавляет новую точку в середину отрезка, концам которого '+
    'соответствует текущая и следующая строки таблицы. Если текущая строка является '+
    'последней, данная команда будет эквивалентна команде <b>Добавить</b>.</li>'+
    '<li><b>Удалить</b>. Удаляет текущую точку.</li>'+
    '</ul>'+
    '<p>Изменения, внесенные в таблицу, автоматически отобразятся на карте и разрезе. </p>',
IDS_TOUR_PERF_SUMMARY_TITLE: 'Редактирование интервалов перфораций',
IDS_TOUR_PERF_SUMMARY_TEXT:
    '<p>Перфорации проектируемых скважин можно задавать и изменять тремя способами: </p>' +
    '<ul>'+
    '<li>Вручную, с помощью мышки на карте либо на разрезе. </li>' +
    '<li>Внося изменения в таблицу <b>Интервалы перфораций</b>. </li>' +
    '<li>С помощью фильтров. </li>'+
    '</ul>',
IDS_TOUR_PERF_TABLE_TITLE: 'Интервалы перфораций',
IDS_TOUR_PERF_TABLE_TEXT:
    '<p>Таблица <b>Интервалы перфораций</b> содержит информацию о ' +
    'событиях на скважине, привязанных к определенной дате. События ' +
    'могут быть двух типов: перфорация или изоляция. Каждая строка ' +
    'таблицы соответствует определенному интервалу перфорации либо изоляции. </p>' +
    '<p>В строку можно вносить изменения, выделяя щелчком мышки нужную ' +
    'ячейку, с последующим ее редактированием. Также можно удалить ' +
    'ее целиком, используя контекстное меню, открывающееся по правой '+
    'кнопке мышки или по значку <b>⋮</b>. </p>' +
    '<p>Изменения, внесенные в таблицу, автоматически отобразятся на ' +
    'карте и разрезе. При этом фильтры в панели <b>Настройки перфораций</b> ' +
    'будут сброшены. </p>',
IDS_TOUR_PERF_INTERACTIVE_TITLE: 'Интерактивное редактирование интервалов перфораций',
IDS_TOUR_PERF_INTERACTIVE_TEXT:
    '<ul>'+
    '<li>Чтобы <b>создать новый</b> интервал, следует навести курсор ' +
    'мышки на траекторию выделенной скважины в требуемой точке и, ' +
    'удерживая нажатой левую кнопку, «протянуть» интервал вдоль ствола ' +
    'скважины. </li>' +
    '<li>Также можно изменить либо удалить целиком существующий интервал. ' +
    'Для этого нужно навести курсор мышки на один из концов. Затем, с ' +
    'целью изменить его положение, удерживая нажатой левую кнопку мышки, ' +
    'переместить курсор вдоль ствола скважины. </li>' +
    '<li>Удалить интервал целиком можно с помощью контекстного меню, ' +
    'предварительно наведя курсор мышки на данный интервал. </li>' +
    '</ul>'+
    '<p>Изменения, произведенные таким образом, автоматически отобразятся в '+
    'таблице интервалов. А фильтры в панели <b>Настройки перфораций</b> будут сброшены. </p>',
IDS_TOUR_PERF_SETTINGS_TITLE: 'Настройки перфораций',
IDS_TOUR_PERF_SETTINGS_TEXT:
    'Перфорации проектируемых скважин можно также задавать с помощью ' +
    'специальных фильтров. Интервалы перфораций будут определятся ' +
    'наложением, используемых фильтров. Изменение настроек этих фильтров ' +
    'приведет к удалению старых интервалов перфораций. ',
IDS_TOUR_PERF_FILTERS:
    '<ul>'+
    '<li><b>Нефтенасыщенность</b>. Перфорированы будут ячейки, удовлетворяющие ' +
    'условию фильтра и находящие в области поиска </li>'+
    '<li><b>Расстояние до ВНК</b>. Перфорированы будут ячейки, центр которых расположен ' +
    'от ВНК на расстоянии, не большим заданного </li>' +
    '<li><b>Глубина</b>. Ствол скважины будет перфорирован в указанном диапазоне глубин. </li>'+
    '</ul>',
IDS_TOUR_WELL_PRODUCTIVE_TITLE: 'Прогноз добычи ',
IDS_TOUR_WELL_PRODUCTIVE_TEXT:
    '<p>При поиске оптимальных мест для бурения новых {0} использовались значения '+
    'их стартовых дебитов. На данной стадии можно сделать прогноз '+
    'среднесрочного дебита {1}. </p>'+
    '<p>Для этого необходимо задать: </p>'+ 
    '<ul>'+
    '<li><b>длительность расчета</b>;</li> '+
    '<li><b>забойное давление</b>.</li> '+
    '</ul>'+
    '<p>По умолчанию все настройки будут идентичны тем, с которыми проводился расчет '+
    'стартового дебита, однако они могут быть изменены. </p>',

IDS_TOUR_PROJECT_PAGE_WELL_PATTERN_TITLE_1: 'Расстановка по шаблону',
IDS_TOUR_PROJECT_PAGE_WELL_PATTERN_TEXT_1: 'На этой стадии можно задать шаблон для расстановки скважин.',
IDS_TOUR_PROJECT_PAGE_WELL_PATTERN_TITLE_2: 'Настройки шаблона',
IDS_TOUR_PROJECT_PAGE_WELL_PATTERN_TEXT_2: 'Здесь можно настроить параметры шаблона для расстановки скважин.',
};

export default { translation };
